const bloxEnglishSubscriptionMessages = {
  label: 'Subscription',
  subscriptions: 'Subscriptions',
  new_subscription: 'New Subscription',
  rate: {
    label: 'Rate',
  },
  nextRate: 'Next Rate',
  termExpires: 'Term Expires',
  termExpired: 'Term Expired',
  expireTime: {
    label: 'Expire Time',
    edit: 'Edit Expire Date',
    success: 'Expire time updated.',
    error: 'Update error: {{error}}',
    noDateSelected: 'No date was selected.',
    invalidDate: 'The selected date is invalid. Please refresh and try again.',
    formatError: 'Could not format the expiration date.',
  },
  nextRetryDate: 'Next Retry Date',
  nextRenewalDate: 'Next Renewal Date',
  graceEnds: 'Grace Ends',
  autorenews: {
    label: 'Auto-Renews',
    success: 'Auto-Renew updated',
    error: 'Error updating Auto-Renew',
  },
  startDate: 'Subscription Start',
  every: 'every',
  for: 'for',
  fields: {
    account: 'Account',
    productId: 'Product ID',
    subscriptionId: 'Subscription ID',
    edition: 'Edition',
  },
  managedOnOriginatingSite:
    'This subscription type can be managed on the originating site.',
  actions: {
    change_rate: 'Change Rate',
    cancel_subscription: 'Cancel Subscription',
  },
  change_rate_wizard: {
    title: 'Change Subscription Rate',
    steps: {
      offers: 'Offers',
      payment: 'Payment',
      review: 'Review',
      confirmation: 'Confirmation',
    },
    alerts: {
      subscription_error: 'Error loading subscription data. Please try again later.',
      missing_data:
        'No subscription or user data available. Please check the IDs and try again.',
    },
    fallbacks: {
      unnamed_subscriber: 'Unnamed Subscriber',
    },
    buttons: {
      processing: 'Processing...',
      confirm_change: 'Confirm Change',
      close: 'Close',
      next: 'Next',
    },
    notifications: {
      change_success: 'Subscription rate changed successfully',
      change_warning: 'Subscription rate change completed (response: {{status}})',
      change_error: 'Error changing subscription rate: {{message}}',
      user_error: 'Error fetching user data: {{message}}',
      subscription_error: 'Error fetching subscription data: {{message}}',
    },
    labels: {
      unknown_status: 'unknown',
    },
    review: {
      taxQuoteWarning:
        'Tax estimate unavailable. Tax will be calculated at checkout and may not be reflected in the total shown.',
      taxUnavailable: 'Unavailable',
    },
  },
  loading: {
    rateDetails: 'Loading rate details...',
  },
  error: {
    fetchingRateDetails: 'Error fetching rate details.',
  },
  transactions: {
    label: 'Transactions',
    history: 'History',
    loading: 'Loading transactions...',
    loadMore: 'Load more',
    transactionDate: 'Transaction Date',
    error: {
      fetching: 'Error fetching transactions.',
    },
    refund: {
      success: 'Refund successful!',
      error: 'Refund error: {{error}}',
      confirmPrompt:
        'Are you sure you want to refund the full amount of this transaction?',
      processing: 'Processing refund...',
      confirmButton: 'Refund {{amount}} {{emoji}}',
      completed: 'Refunded',
      issueButton: 'Issue Refund',
    },
    refundId: 'Refund ID',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    amount: 'Amount',
    duration: 'Duration',
    durationDays: '{{days}} days',
    taxAmount: 'Tax Amount',
    taxRegion: 'Tax Region',
    taxRate: 'Tax Rate',
    id: 'Transaction ID',
    filters: {
      title: 'Filter Transactions',
      transactionId: 'Transaction ID',
      userUuid: 'User UUID',
      externalId: 'External ID',
      product: 'Product',
      serviceName: 'Service Name',
      formName: 'Form Name',
      transactionState: {
        label: 'Transaction State',
        all: 'All States',
        succeeded: 'Succeeded',
        failed: 'Failed',
        gateway_processing_failed: 'Gateway Processing Failed',
        gateway_processing_result_unknown: 'Gateway Status Unknown',
      },
      transactionType: {
        label: 'Transaction Type',
        all: 'All Types',
        purchase: 'Purchase',
        authorization: 'Authorization',
        capture: 'Capture',
        credit: 'Credit',
        refund: 'Refund',
        void: 'Void',
        replace_payment_method: 'Replace Payment Method',
        invalid_replace_payment_method: 'Invalid Replace Payment Method',
        contact_card_holder: 'Contact Card Holder',
        close_payment_method: 'Close Payment Method',
      },
      application: {
        label: 'Application',
        all: 'All Applications',
        subscriptions: 'Subscriptions',
        forms: 'Forms',
        adowl: 'AdOwl',
        classifieds: 'Classifieds',
      },
      testStatus: {
        label: 'Test Status',
        all: 'All',
        test: 'Test',
        live: 'Live',
      },
      paymentHandler: {
        label: 'Payment Handler',
        all: 'All Handlers',
        payflow_pro: 'Payflow Pro',
        elavon_authorize: 'Elavon Authorize',
        paypal: 'PayPal',
        adyen: 'Adyen',
        other: 'Other',
      },
      paymentType: {
        label: 'Payment Type',
        all: 'All Types',
        purchase: 'Purchase',
        authorization: 'Authorization',
        capture: 'Capture',
        credit: 'Credit',
        refund: 'Refund',
        void: 'Void',
        replace_payment_method: 'Replace Payment Method',
        invalid_replace_payment_method: 'Invalid Replace Payment Method',
        contact_card_holder: 'Contact Card Holder',
        close_payment_method: 'Close Payment Method',
      },
      subscriptionService: {
        label: 'Subscription Service',
        all: 'All Services',
        digital_access: 'Digital Access',
        print_delivery: 'Print Delivery',
      },
      citMit: {
        label: 'CIT / MIT',
        all: 'All',
        cit: 'CIT',
        mit: 'MIT',
      },
      initiatedBy: {
        label: 'Initiated By',
        all: 'All',
        customer: 'Customer',
        admin: 'NXT Admin',
        system: 'System',
      },
      lifecycle: {
        label: 'Subscription Lifecycle',
        all: 'All',
        renewal: 'Renewal',
        new_start: 'New Start',
      },
      dateFrom: 'Transaction Date From',
      dateTo: 'Transaction Date To',
      transactionDate: 'Transaction Date Range',
    },
    table: {
      date: 'Date / Time',
      customer: 'Customer Name',
      type: 'Type',
      amount: 'Amount',
      state: 'Status',
      paymentHandler: 'Payment Handler',
      email: 'Email',
      application: 'Application',
      test: 'Test',
      stateValues: {
        succeeded: 'Succeeded',
        failed: 'Failed',
        gateway_processing_failed: 'Gateway Processing Failed',
        gateway_processing_result_unknown: 'Gateway Status Unknown',
      },
    },
    search: {
      placeholder: 'Search transactions...',
    },
    breadcrumbs: {
      backToSearch: 'Back to search results',
      search: 'Transactions Search',
    },
    detail: {
      untitled: 'Transaction Details',
      customer: 'Customer',
      customerName: 'Customer Name',
      email: 'Email',
      phone: 'Phone',
      openCustomerProfile: 'Open Customer Profile',
      addresses: {
        billing: 'Billing Address',
        shipping: 'Shipping Address',
      },
      transaction: 'Transaction Details',
      message: 'Message',
      error: 'Error',
      paymentHandler: 'Payment Handler',
      transactionId: 'Transaction ID',
      description: 'Description',
      overviewTitle: 'Transaction Overview',
      totalAmount: 'Total Amount',
      date: 'Date',
      latestActivity: 'Latest Activity',
      paymentMethodTitle: 'Payment Method',
      viewCard: 'View Card',
      unknownProcessor: 'Unknown processor',
      paymentUnavailable: 'Payment details unavailable.',
      statusUpdate: 'Status update',
      testTransaction: 'Test Transaction',
      liveTransaction: 'Live Transaction',
      testModeLabel: 'Mode',
      gatewayDetails: 'Gateway Details',
      metadata: 'Metadata',
      processedBy: 'Processed by',
      userWidgetTitle: 'User',
      user: {
        loadError: 'Unable to load user information.',
        noUser: 'No user is associated with this transaction.',
      },
      errors: {
        notFound: 'Transaction not found',
        missingId: 'Missing transaction ID',
        missingUserId: 'Missing user ID',
        missingPaymentIdentifiers: 'Missing payment method identifiers',
      },
      fields: {
        state: 'State',
        paymentToken: 'Payment Token',
        avsResponse: 'AVS Response',
        cvvResponse: 'CVV Response',
        spreedlyToken: 'Spreedly Token',
        ipAddress: 'IP Address',
        rateName: 'Rate Name',
        recurring: 'Recurring',
      },
      recurring: {
        yes: 'Yes',
        no: 'No',
      },
    },
  },
  paymentMethod: {
    label: 'Payment Method',
    changeButton: 'Change Payment Method',
    expiredWarning: 'This card is expired and needs to be updated.',
    selectTitle: 'Select Payment Method',
    noMethodAvailable: 'No payment methods available.',
    preferred: 'Preferred',
    expired: 'Expired',
    expires: 'Expires',
    addCard: 'Add Card',
    addNewCard: 'Add New Card',
    addCardCaption: 'Or add a card',
    failedToLoad: "We couldn't load your payment methods. Please try again.",
    noValidPaymentMethods: 'No valid payment methods found for this account.',
    new_card_success: 'New card added successfully',
    removeError: 'Failed to remove payment method',
    updateError: 'Failed to update payment method',
    notAvailable: 'N/A',
    details: {
      title: 'Payment Details',
      cardholder: 'Cardholder',
      name: 'Name',
      expiration: 'Expiration',
      billingAddress: 'Billing Address',
      street: 'Street',
      cityStateZip: 'City / State / ZIP',
      country: 'Country',
      activity: 'Activity',
      created: 'Created',
      lastUpdated: 'Last Updated',
      addedVia: 'Added via {{wallet}}',
      paypalAccount: 'PayPal Account',
      wallet: 'Wallet',
      unknownCard: 'Unknown Card',
    },
  },
  detail: {
    loading: 'Loading subscription details...',
  },
  ltv: {
    defaultName: 'This customer',
    tooltipText:
      'Life Time Value (LTV) is the sum of this customers payments throughout the life of their subscriptions and any other transactions through BLOX.',
    label: 'Customer LTV:',
    shortLabel: 'LTV:',
    hasContributed: 'has contributed {{amount}}',
    hasNotContributed: 'has not contributed',
    since: ' since {{startdate}}',
  },
  search: {
    new_starts: 'New Starts',
    new_starts_info: 'Active and started within the last 30 days',
    stops: 'Stops',
    stops_info: 'Canceled within the last 30 days',
  },
  rate_modal: {
    title: {
      add: 'Add Rate',
      edit: 'Edit Rate',
    },
    actions: {
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
    },
    sections: {
      general: 'General',
      lifecycle: 'Lifecycle',
      transition: 'Transition Settings',
      additional_settings: 'Additional Settings',
      preview: 'Preview',
    },
    messages: {
      failed_to_save: 'Failed to save rate',
      fix_validation_errors: 'Please fix the validation errors below.',
    },
    service_warnings: {
      disabled:
        'This Service is Disabled, so users cannot purchase this rate until the Service is enabled.',
      hidden:
        'This Service is Hidden, so users cannot purchase this rate until the Service is enabled.',
      test: 'This Service is in Test Mode, so this rate can only be purchased with test cards.',
    },
    promo_code_validation: {
      empty: 'Promo code cannot be empty',
      max_length: 'Promo code cannot exceed 50 characters',
      invalid_format:
        'Promo code can only contain letters, numbers, hyphens, and underscores',
      duplicate: 'This promo code already exists',
    },
    fields: {
      name: {
        label: 'Rate Name',
        validation: {
          required: 'Rate name is required',
          max_length: 'Rate name cannot exceed 40 characters',
        },
        description:
          'This name will appear in admin search and on customer emails (40 char max)',
      },
      price: {
        label: 'Price',
        placeholder: '0.00',
        validation: {
          required: 'Price is required',
          valid_price: 'Please enter a valid price',
          greater_than_zero: 'Price must be greater than $0.00',
          max_amount: 'Price cannot exceed $999,999.99',
        },
        help: {
          format: 'Enter amount in dollars (e.g., 4.50 for $4.50)',
          editing_disabled: 'Price cannot be edited after initial save',
        },
      },
      duration: {
        label: 'Term (days)',
        validation: {
          required: 'A valid term is required',
          valid_number: 'Please enter a valid number of days greater than 0',
        },
        help: {
          format: 'Duration in days (e.g., 28)',
          editing_disabled: 'Duration cannot be edited after initial save',
        },
      },
      terms: {
        label: 'Terms',
        description: 'Legal terms for this rate',
      },
      start_date: {
        label: 'Start Date and Time',
        description: 'When the rate becomes available (default is now)',
      },
      always_available: {
        label: 'Rate is Always Available',
      },
      end_date: {
        label: 'Rate Ends On',
        description: 'When the rate stops being available',
      },
      hide_date: {
        label: 'Available Until',
        description: 'Last date and time when rate can be purchased',
      },
      enable_rate_changes: {
        label: 'Enable Rate Changes',
      },
      end_cycles: {
        label: 'Total Transactions',
        validation: {
          required: 'Total transactions is required',
          valid_number: 'Please enter a valid number of transactions greater than 0',
        },
        description: 'Number of times this rate will be charged before transitioning',
      },
      end_id: {
        label: 'Followed By',
        validation: {
          required: 'You must select a follow-up rate',
        },
        placeholder: {
          loading: 'Loading rates...',
          search: 'Search and select a rate...',
        },
        help: {
          loading: 'Loading available rates...',
          choose: 'Choose from {{count}} active rates',
        },
        no_options: {
          loading: 'Loading rates...',
          no_rates: 'No active rates available',
          no_match: 'No rates match your search',
        },
      },
      save_rate: {
        label: 'Save Rate for Cancellation',
        description: 'Make this rate a "Save Rate" for retention offers on cancellations',
      },
      hidden: {
        label: 'Hide Rate from Website',
        description: 'This rate will only be used for auto-renewing transactions',
        warning:
          'Hiding this rate will not allow users to purchase it on the website. This rate can only be used for auto-renewing transactions. To allow users to purchase it, turn Hide Rate OFF.',
      },
      external_id: {
        label: 'External ID',
        description: 'Optional identifier for integration with external systems',
        placeholder: 'Enter external identifier (optional)',
        validation: {
          max_length: 'External ID cannot exceed 100 characters',
        },
      },
      promo_needs_code: {
        label: 'Require Promo Code',
        description: 'Users must enter a promo code to access this rate',
      },
      promo_codes: {
        label: 'Promo Codes',
        placeholder: 'Enter promo codes (e.g., SAVE20, WELCOME)',
        validation: {
          required_when_enabled:
            'At least one promo code is required when "Require Promo Code" is enabled',
        },
        help: {
          mobile: 'Tap Enter to add codes. Tap chips to remove.',
          desktop:
            'Press Enter or comma to add promo codes. Use Backspace to remove the last code.',
          validation_rules:
            'Promo codes are automatically converted to uppercase and can only contain letters, numbers, hyphens, and underscores. Maximum 50 characters each.',
        },
        warning: {
          required_but_empty:
            'You have enabled "Require Promo Code" but haven\'t added any promo codes. Users will not be able to access this rate until you add at least one promo code.',
        },
      },
    },
    transition: {
      for: 'for',
      days: 'days',
      save_rate_chip: 'SAVE RATE',
      ends: 'ENDS',
    },
    preview: {
      title: 'Rate Preview',
      new_rate: 'New Rate',
      for: 'for',
      days: 'days',
      charged: 'Charged',
      time: 'time',
      times: 'times',
      then: 'then',
      auto_renews_indefinitely: 'Then auto-renews indefinitely',
      expires_without_auto_renewal: 'Then expires without auto-renewal',
      terms: 'Terms',
      promo_codes: 'Promo Codes',
      required: 'Required',
      blox_rate_id: 'BLOX Rate ID',
      external_id: 'External ID',
      will_be_generated: 'Will be generated on save',
      copy_blox_rate_id: 'Copy BLOX Rate ID',
      blox_rate_id_copied: 'BLOX Rate ID copied!',
      copy_external_id: 'Copy External ID',
      external_id_copied: 'External ID copied!',
    },
  },
  deliveryPhone: 'Delivery Phone',
  deliveryAddress: {
    label: 'Delivery Address',
    edit: 'Edit Delivery Address',
    editTitle: 'Edit Delivery Address',
    line1: 'Address Line 1',
    line2: 'Address Line 2',
    city: 'City',
    state: 'State/Region',
    country: 'Country',
    zip: 'Zip Code',
    phone: 'Phone Number',
    phoneHelperText: 'Please enter a valid 10-digit phone number',
    requiredFields: 'Please fill in all required fields',
    invalidPhone: 'Please enter a valid phone number',
    updateSuccess: 'Delivery address updated successfully',
    updateError: 'Failed to update delivery address: {error}',
  },
  new_sub_wizard: {
    title: 'Start a new subscription',
    steps: {
      userDetails: 'User Details',
      packageSelection: 'Package Selection',
      paymentDetails: 'Payment Details',
      reviewPurchase: 'Review Purchase',
      confirmation: 'Confirmation',
    },
    buttons: {
      processing: 'Processing...',
      createUserAndContinue: 'Create User & Continue',
      purchase: 'Purchase',
      returnToReview: 'Return to Review',
      next: 'Next',
      closeWizard: 'Close Wizard',
    },
    notifications: {
      userCreated: 'New user account created successfully',
      subscriptionCreated: 'Subscription created successfully',
      passwordResetSent: 'User Created & Password reset email sent successfully',
      passwordResetError: 'Error sending password reset email: {{message}}',
      subscriptionError: 'Error Creating Subscription: {{message}}',
      fetchUserError: 'Error fetching user data: {{message}}',
    },
    errors: {
      missingData: 'Missing required data for purchase',
    },
    review: {
      title: 'Review and Purchase',
      confirmationEmail: 'Confirmation email will be sent to:',
      cards: {
        userInformation: 'User Information',
        subscription: 'Subscription',
        paymentAndSubscription: 'Payment & Subscription',
      },
      labels: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        primaryAddress: 'Primary Address',
        service: 'Service',
        freeServiceFallback: 'Free Service',
        deliveryAddress: 'Delivery Address',
        deliveryRequired: 'Delivery address is required for this service.',
        cost: 'Cost',
        freeServiceCost: 'No payment required (free service)',
        billingAddress: 'Billing Address',
        plan: 'Plan',
        pricing: 'Pricing',
        subtotal: 'Subtotal',
        tax: 'Tax',
        total: 'Total',
      },
      editMenu: {
        editPayment: 'Edit Payment',
        editSubscription: 'Edit Subscription',
      },
      errors: {
        missingInfo: 'Missing required information for review.',
        missingRate: 'Missing required rate for a paid service.',
        missingPaymentMethod: 'Missing required payment method for a paid service.',
        taxQuoteWarning:
          'Tax estimate unavailable. Tax will be calculated at checkout and may not be reflected in the total shown.',
        taxUnavailable: 'Unavailable',
      },
    },
  },
  cancel_wizard: {
    title: 'Cancel Subscription',
    steps: {
      reason: 'Reason',
      offers: 'Offers',
      review: 'Review',
      confirmation: 'Confirmation',
    },
    buttons: {
      processing: 'Processing...',
      continue_to_cancel: 'No, Continue to Cancel',
      confirm_rate_change: 'Confirm Rate Change',
      confirm_cancel: 'Confirm Cancel',
      accept_offer: 'Yes, Accept Offer',
      select_rate_placeholder: 'Please select a rate...',
    },
    notifications: {
      cancel_success: 'Canceled Subscription',
      update_success: 'Updated Subscription',
    },
    alerts: {
      loading_error: 'Error loading data. Please try again later.',
      expire_warning: "{{name}}'s subscription will expire on",
    },
    cancel_reasons: {
      title: 'Why are you wanting to cancel?',
      select_reason: 'Select a reason',
      notes_label: 'Notes',
      notes_helper: '{{count}}/200 characters',
      error_fetching: 'Error fetching cancel reasons.',
      benefits_lost: 'After that date access to these benefits will be lost:',
    },
    errors: {
      fetching_benefits: 'Error fetching benefit details.',
    },
    save_offers: {
      title: 'Can we offer you a special price to stay?',
      current_rate: "{{name}}'s current rate is {{price}} / {{duration}}",
      show_hidden_rates: 'Show Hidden Rates',
      save_offers_only: 'Save Offers Only',
      will_pay: 'will pay',
      same_amount: 'the same amount.',
      select_rate_prompt: 'Please select a rate to compare.',
      save_offer_chip: 'Save Offer',
      no_results: 'No results found.',
      showing_results: 'Showing {{shown}} of {{total}} total results.',
      error_fetching_rates: 'Error fetching comparison rates.',
      no_other_rates: 'No other rates are available.',
      rates_label: 'Rates',
      compare: {
        daily: 'Daily',
        monthly: 'Monthly',
        yearly: 'Yearly',
        less: 'less',
        more: 'more',
      },
    },
    review: {
      title: 'Review and Confirm Changes',
      changing_rate: '{{name}} is changing to a new rate.',
      new_rate_begins: 'New rate begins on {{date}}',
      card_will_be_charged: 'Card on file will be charged {{amount}}',
      terms_prefix: 'Terms:',
      expire_warning: "{{name}}'s subscription will expire on",
      benefits_lost: 'After that date access to these benefits will be lost:',
      error_fetching_benefits: 'Error fetching benefit details.',
    },
    confirm: {
      new_rate_title: 'Confirmed — New Rate Accepted',
      cancel_title: 'Confirmed — Subscription Canceled',
      subscription_updated: "{{name}}'s subscription has been updated.",
      subscription_canceled: "{{name}}'s subscription has been canceled.",
      new_rate_begins: 'New rate begins on {{date}}',
      access_ends: 'Access will end on {{date}}.',
      confirmation_email_sent: 'A confirmation email has been sent to',
    },
  },
};

const bloxEnglishServiceMessages = {
  label: 'Services',
  breadcrumbs: {
    backToSearch: 'Back to search results',
    search: 'Services Search',
  },
  delimited: {
    manager: {
      steps: {
        uploadFile: 'Upload File',
        mapColumns: 'Map Columns',
        cleanData: 'Clean Data',
        confirmImport: 'Confirm Import',
        results: 'Results',
      },
      processing: {
        uploading: 'Uploading your file...',
        verifying: 'Verifying data...',
        checkingErrors: 'Checking for errors...',
      },
      navigation: {
        back: 'Back',
        next: 'Next',
        startImport: 'Start Import',
        processing: 'Processing...',
        selectFile: 'Select a file to continue',
      },
      errors: {
        unknownStep: 'Unknown step',
        unresolvedErrors:
          'You cannot progress until all errors are fixed. Edit each row with an issue, then try Next again.',
      },
      confirmMappingDialog: {
        title: 'Confirm Mapping Updates',
        unmapped: 'Not mapped',
        columnLabel: 'Column {{value}}',
        headerLabel: 'Header row',
        delimiterLabel: 'Delimiter',
        enclosureLabel: 'Text qualifier',
        messageWithChangesIntro: 'Saving this column mapping will update the following:',
        message:
          'Saving this column mapping will update the service configuration for all future uploads. Continue?',
        unsetValue: 'None',
        headerEnabled: 'Header row: Enabled',
        headerDisabled: 'Header row: Disabled',
      },
    },
    upload: {
      title: 'Upload CSV File',
      subtitle: 'Select or drag your CSV file to begin the import process',
      dropzone: {
        processing: 'Processing your file...',
        validating: 'Validating data and checking for errors',
        invalidFile: 'Invalid file selected',
        selectValid: 'Please select a valid CSV file',
        fileReady: 'File ready for import',
        dropHere: 'Drop your CSV file here',
        orBrowse: 'or click to browse',
        maxSize: 'Maximum file size: 50MB • CSV format only',
      },
      buttons: {
        removeFile: 'Remove File',
        changeFile: 'Change File',
        showLess: 'Show Less',
        viewAll: 'View All {{count}} Rows',
      },
      settings: {
        hasHeaders: {
          label: 'First row contains headers',
          withHeaders: 'Headers will be used for column mapping',
          withoutHeaders: 'Columns will be named generically',
        },
      },
      stats: {
        rows: 'Rows',
        columns: 'Columns',
      },
      preview: {
        title: 'Data Preview',
        showingAll: 'Showing all {{count}} rows',
        showingPartial: 'Showing first {{shown}} of {{total}} rows',
        empty: 'empty',
        showLess: 'Show preview only',
        viewAll: 'View all rows',
      },
      errors: {
        validation: {
          title: 'File Validation Error',
          invalidType:
            'Invalid file type. Please upload a CSV file. You uploaded: {{fileName}}',
          invalidFormat: 'Invalid file format. Expected CSV but got {{fileType}}',
          tooLarge: 'File too large ({{size}}). Maximum size is 50MB.',
          empty: 'File is empty. Please upload a CSV file with data.',
          onlyOne: 'Only one file can be provided at a time.',
        },
        upload: {
          title: 'Upload Failed',
          helpText:
            'Please check your file format and try again. If the problem persists, contact support.',
        },
        processing: {
          title: 'File Processing Issues',
          description:
            "The file was uploaded but couldn't be processed properly. Common causes:",
          causes: {
            delimiter: 'Incorrect delimiter (should be comma-separated)',
            encoding: 'Text encoding issues (save as UTF-8)',
            structure: 'Malformed CSV structure',
            dataTypes: 'Mixed data types in columns',
          },
          suggestion:
            'Try opening in a spreadsheet application and re-saving as CSV (UTF-8).',
        },
      },
    },
    mapping: {
      title: 'Map CSV Columns',
      subtitle: 'Match your CSV columns to the system fields for proper data import',
      detection: {
        title: 'Column Detection',
        allMapped: 'All required fields mapped',
        fieldsDetected: '{{count}} fields auto-detected',
        instruction: 'Map your CSV columns to system fields',
        retrying: 'Retrying AI detection (attempt {{attempt}} of {{max}})',
      },
      buttons: {
        aiDetect: 'AI Auto-Detect',
        reDetect: 'Re-detect',
        detecting: 'Detecting...',
        retrying: 'Retrying...',
      },
      field: {
        selectPlaceholder: 'Select field...',
        sample: 'Sample: {{value}}',
        mappedTo: 'Mapped to {{fieldName}}',
        used: 'Used',
        required: 'Required',
      },
      alerts: {
        success: 'AI mapped {{count}} columns successfully',
        error: {
          title: 'AI Detection Failed',
          generic: 'AI mapping failed. Please map columns manually.',
          instruction: 'Please map your columns manually using the dropdowns below.',
        },
        missingFields: {
          title: 'Missing required fields',
          fields: '{{fields}}',
        },
      },
      ai: {
        analyzing: 'AI is analyzing your columns',
        detecting: 'Detecting the best matches...',
        retrying: 'Retrying after a temporary error (attempt {{attempt}} of {{max}})...',
        badge: 'AI',
      },
      autoMap: {
        noHeaders: 'AI mapping requires headers in the CSV file',
      },
    },
    cleanup: {
      title: 'Review Data Quality',
      subtitle: 'Review and fix any data issues before importing',

      checking: {
        checking: 'Checking for errors',
        rechecking: 'Re-checking for errors',
        attempt: 'Check #{{attempt}}',
      },

      recheck: {
        info: 'Fixed {{fixed}} of {{previous}} errors. {{remaining}} error{{plural}} remaining.',
        success: 'Successfully fixed all {{count}} errors!',
      },

      healthScore: {
        title: 'Data Health Score',
        description: '{{clean}} of {{total}} rows are clean',
      },

      pending: {
        title: '{{count}} pending change{{plural}}',
        description:
          '{{modified}} edit{{modifiedPlural}}, {{deleted}} deletion{{deletedPlural}} not yet applied',
        apply: 'Apply Changes ({{count}})',
        discard: 'Discard',
      },

      rowEditModal: {
        title: 'Edit Row {{row}}',
        titleNoRow: 'Edit Row',
        saveRow: 'Save Row',
        deleteRow: 'Delete Row',
        noChanges: 'No changes made. Update a field to resolve the issue.',
      },

      alerts: {
        summary:
          'Found {{errors}} issue{{errorPlural}} in {{rows}} row{{rowPlural}}. Click Edit to fix them.',
        noErrors: {
          title: 'Perfect! All Data Validated',
          description: 'Your data is clean and ready for import with no issues detected',
        },
        tooManyErrors: {
          title: 'Too Many Errors to Edit',
          description:
            'This CSV contains too many errors to fix here. Please review and correct the source file, then upload again.',
        },
      },

      table: {
        title: {
          default: 'Data with Issues',
          editMode: 'Click any cell to edit',
        },
        headers: {
          row: 'Row',
          more: 'More',
          issues: 'Issues',
          actions: 'Actions',
        },
        moreFields: '+{{count}} fields',
        issueCount: '{{count}} issue{{plural}}',

        expanded: {
          issuesFound: 'Issues found in row {{row}}:',
          editData: 'Edit Row Data:',
          viewData: 'Row Data:',
          collapse: 'Collapse',
          expand: 'Expand to see all fields',
          enterValue: 'Enter {{header}}',
          deletedNotice:
            'This row has been marked for deletion and will be removed during import.',
        },

        chips: {
          deleted: 'Deleted',
          modified: 'Modified',
        },

        showing: {
          all: 'Showing all {{count}} rows with errors',
          partial: 'Showing {{shown}} of {{total}} rows with errors',
        },

        buttons: {
          viewAll: 'View All {{count}} Error Rows',
          showLess: 'Show Less',
        },

        actions: {
          editRow: 'Edit',
          deleteRow: 'Delete row',
          undoDelete: 'Undo delete',
        },

        badges: {
          modified: 'M',
          deleted: 'D',
        },

        empty: '-',
      },

      errors: {
        truncated: '+{{count}}',
      },

      tooltips: {
        showAll: 'View all error rows',
        showLess: 'Show preview only',
      },
    },
    dataViewer: {
      title: 'File Upload',
      uploadCsvButton: 'Upload CSV',
      exportButton: 'Export',
      lastUpdated: 'last updated {{relative}}',
      download: {
        tooltip: 'Download the most recent processed file',
      },
      preview: {
        title: 'Data Preview',
        showing: 'Showing first {{shown}} of {{total}} rows',
      },
      search: {
        placeholder: 'Search records...',
        clear: 'Clear search',
      },
      viewAll: 'View All {{total}} Rows',
      empty: {
        noRecords: 'No subscriber records have been processed yet.',
        noMatches: 'No records match your search.',
      },
      errors: {
        loadFailed: 'Failed to load subscriber records.',
      },
      export: {
        queued:
          'Preparing CSV export. You will receive a notification when it is ready to download.',
        error: 'Failed to start CSV export.',
      },
      modal: {
        title: 'All Records',
        subtitle: 'Total: {{total}} records',
        downloadCsv: 'Download CSV',
        loadingMore: 'Loading more records...',
      },
    },
    preview: {
      title: 'Review & Confirm Import',
      subtitle: 'Review your data before importing',
      summary: {
        title: 'Import Summary',
        fileName: 'File Name',
        totalRecords: 'Total Records',
        recordsCount: '{{count}} rows',
        dataStatus: 'Data Status',
        allValid: 'All rows valid',
        validWithIssues: '{{valid}} valid / {{errors}} with issues',
        unknown: 'Unknown',
      },
      alerts: {
        warning: {
          title: '{{count}} rows have issues.',
          description:
            'These rows may fail during import. You can go back to the previous step to fix them, or proceed with the import.',
        },
        success: {
          title: 'Ready to import {{count}} records.',
          description: 'Click "Start Import" to begin the process.',
        },
      },
      dataPreview: {
        title: 'Data Preview',
        showingAll: 'Showing all {{count}} rows',
        showingPartial: 'Showing first {{shown}} of {{total}} rows',
        empty: 'empty',
        buttons: {
          showLess: 'Show Less',
          viewAll: 'View All {{count}} Rows',
        },
      },
      tooltips: {
        showAll: 'View all rows',
        showLess: 'Show preview only',
      },
    },
    results: {
      title: 'Import Complete',
      subtitle: 'Your import has been processed',
      success: {
        title: 'Import Completed Successfully',
        description: '{{count}} records have been imported to your system',
      },
      error: {
        title: 'Import Failed',
        duplicateAccount: 'Duplicate account number "{{account}}" found on line {{line}}',
      },
      summary: {
        title: 'Import Summary',
        fileName: 'File Name',
        recordsCount: '{{count}} rows',
        rowsProcessed: 'Rows Processed',
        completedAt: 'Completed At',
        status: 'Status',
        statusSuccess: 'Success',
        statusFailed: 'Failed',
        unknown: 'Unknown',
      },
      help: {
        title: 'What to do next:',
        items: {
          checkDuplicates: 'Check for duplicate account numbers in your CSV file',
          ensureFields: 'Ensure all required fields are properly mapped',
          fixRows: 'Remove or fix any problematic rows and try again',
          contactSupport: 'Contact support if the issue persists',
        },
      },
      preview: {
        title: 'Imported Records Preview',
        showingAll: 'Showing all {{count}} imported records',
        showingPartial: 'Showing first {{shown}} imported records',
        empty: 'empty',
        buttons: {
          showLess: 'Show Less',
          viewAll: 'View All {{count}} Records',
        },
      },
      tooltips: {
        showAll: 'View all records',
        showLess: 'Show preview only',
      },
    },
  },
  details: {
    label: 'Service Details',
    loading: 'Loading Service',
    error: {
      missingId: 'Error: Service ID is missing from the URL',
      loading: 'Error loading service details',
      update: 'Error updating service: {{message}}',
      copy: 'Failed to copy service ID',
      create: 'Failed to create service',
    },
    success: {
      update: 'Service updated successfully',
      create: 'Service created successfully',
      copy: 'Copied!',
    },
    header: {
      serviceId: 'ID: {{id}}',
      copyTooltip: 'Copy ID',
      copyAriaLabel: 'Copy service ID',
      sectionLabel: 'Services',
      save: 'Save',
      saveChanges: 'Save Changes',
      saving: 'Saving',
      savingWithEllipsis: 'Saving...',
      createService: 'Create Service',
      creatingWithEllipsis: 'Creating...',
      expandDetails: 'Expand details',
      collapseDetails: 'Collapse details',
    },
    sections: {
      serviceSettings: 'Service Settings',
      purchaseRates: 'Purchase Rates',
      emailNotifications: 'Email Notifications',
      domainManagement: 'Domain Management',
      fileUpload: 'File Upload',
    },
    accordions: {
      generalSettings: {
        label: 'General Settings',
      },
      configuration: {
        label: 'Configuration',
      },
      customProperties: {
        label: 'Custom Properties',
      },
    },
    warnings: {
      title: 'Confirm Change',
      disabled: {
        enable: {
          message:
            'Enabling this service will allow users to purchase and renew subscriptions. Are you sure you want to enable this service?',
          confirmButton: 'Yes, Enable Service',
        },
        disable: {
          message:
            'Disabling this service will cancel subscriptions and break renewals. Are you sure you want to disable this service?',
          confirmButton: 'Yes, Disable Service',
        },
      },
      hidden: {
        hide: {
          message:
            'Hiding this service will prevent users from seeing it, but they can still autobind to it. Are you sure you want to hide this service?',
          confirmButton: 'Yes, Hide Service',
        },
        unhide: {
          message:
            'Unhiding this service will make it visible to users on the website. Are you sure you want to unhide this service?',
          confirmButton: 'Yes, Unhide Service',
        },
      },
      testmode: {
        enable: {
          message:
            'Switching to testing mode will only allow test cards for purchases. Are you sure you want to switch to testing mode?',
          confirmButton: 'Yes, Switch to Testing Mode',
        },
        disable: {
          message:
            'Switching to live mode will only allow real credit cards for purchases. Are you sure you want to switch to live mode?',
          confirmButton: 'Yes, Switch to Live Mode',
        },
      },
    },
    fields: {
      name: 'Name',
      description: 'Description',
      disabled: 'Disabled',
      hidden: 'Hidden',
      testmode: 'Test Mode',
      type: 'Type',
    },
    customProperties: {
      key: 'Key',
      value: 'Value',
      add: 'Add Custom Property',
      remove: 'Remove',
      errors: {
        keyEmpty: 'Key cannot be empty.',
        keyExists: 'Key "{{key}}" already exists.',
      },
      title: 'Custom Properties',
      caption: 'Custom properties allow you to add metadata to your service',
      about: {
        title: 'About Custom Properties',
        description:
          'Properties are key-value pairs that can be used to store additional configuration data for your service.',
      },
      empty: 'No custom properties defined. Click "Add Custom Property" to create one.',
      propertyName: 'Property Name',
      propertyValue: 'Property Value',
      placeholders: {
        name: 'Enter property name',
        value: 'Enter property value',
      },
      removeTooltip: 'Remove property',
      removeAriaLabel: 'Remove property {{name}}',
    },
    noDescription: 'No description provided',
    configuration: {
      loading: 'Loading configuration...',
      noFields: 'No configuration fields available for this service type.',
      sections: {
        service: 'Service Configuration',
        payment: 'Payment Configuration',
        tax: 'Tax Configuration',
        additional: 'Additional Configuration',
      },
    },
    generalSettings: {
      fields: {
        serviceName: {
          label: 'Service Name',
          tooltip: 'Enter the name for this service',
        },
        notificationEmail: {
          label: 'Notification Email',
          help: 'Email address for service notifications',
          tooltip: 'Enter the email address where service notifications will be sent',
        },
        linkedAccounts: {
          label: 'Allow Linked Accounts',
          help: 'Allow users to link multiple accounts',
          tooltip:
            'Enable this to allow users to connect multiple accounts to this service',
        },
        deliveryRequired: {
          label: 'Require Delivery Address',
          help: 'Mandate delivery information',
          tooltip: 'Require users to provide delivery address information',
        },
        disabled: {
          label: 'Service Disabled',
          help: 'Temporarily disable the service',
          tooltip: 'When enabled, this service will be temporarily unavailable',
        },
        hidden: {
          label: 'Hide from Public',
          help: 'Hide service from public view',
          tooltip: 'When enabled, this service will not be visible to users',
        },
        testMode: {
          label: 'Testing Mode',
          help: 'Enable testing environment',
          tooltip: 'Enable test mode for development and testing purposes',
        },
        description: {
          label: 'Service Description',
          help: 'Provide details about what this service offers',
        },
      },
    },
    rates: {
      searchPlaceholder: 'Search rates...',
      searchAriaLabel: 'Search rates',
      clearTooltip: 'Clear input',
      clearAriaLabel: 'Clear search',
      activeOnly: 'Active Only',
      results: {
        count: '{{filtered}} of {{total}} results',
        none: 'No results.',
      },
      error: {
        loadFailed: 'Failed to load rates after {{attempts}} attempts. Please try again.',
        retry: 'Retry',
      },
      columns: {
        name: 'Name',
        amount: 'Amount',
        duration: 'Duration',
        currency: 'Currency',
        isSaveRate: 'Is Save Rate',
        activeUsers: 'Active Users',
      },
      isSaveRate: {
        yes: 'Yes',
        no: 'No',
      },
    },
    domainManagement: {
      description: 'Manage the domains associated with this service.',
      addButton: 'Add',
      pasteButton: 'Paste',
      copyButton: 'Copy',
      sortButton: 'Sort',
      sortAsc: 'Sort A to Z',
      sortDesc: 'Sort Z to A',
      clearSort: 'Clear sorting',
      noDomains: 'No domains have been added to this service yet.',
      noResults: 'No domains match your search.',
      domainCount: '{{count}} domain(s)',
      removeTooltip: 'Remove domain',
      pasteTooltip: 'Paste domains from clipboard',
      copyTooltip: 'Copy all domains to clipboard',
      sortTooltip: 'Sort domains alphabetically',
      searchPlaceholder: 'Search domains...',
      searchAriaLabel: 'Search domains',
      clearTooltip: 'Clear search',
      clearAriaLabel: 'Clear search',
      results: {
        count: '{{filtered}} of {{total}} results',
        none: 'No domains',
      },
      success: {
        update: 'Domains updated successfully',
        copy: 'Domains copied to clipboard',
        paste: '{{count}} domain(s) added',
      },
      error: {
        update: 'Failed to update domains: {{message}}',
        duplicate: 'This domain already exists in the list',
        copy: 'Failed to copy domains to clipboard',
        paste: 'Failed to read from clipboard',
        noDomainsToPaste: 'No domains found in clipboard',
      },
      info: {
        allDuplicates: 'All pasted domains already exist in the list',
      },
      modal: {
        title: 'Add Domain',
        description: 'Enter the domain name you want to add to this service.',
        label: 'Domain Name',
        placeholder: 'example.com',
        addButton: 'Add Domain',
        adding: 'Adding...',
        willBeAddedAs: 'Will be added as: {{domain}}',
        error: {
          empty: 'Please enter a domain name',
          invalid: 'Please enter a valid domain name (e.g., example.com)',
          duplicate: 'This domain already exists in the list',
        },
      },
    },
    notifications: {
      subscriberMessaging: 'Subscriber Messaging',
      adminNotifications: 'Admin Notifications',
    },
  },
  new: {
    title: 'New {{type}} Service',
    error: {
      missingType: 'Service type is required',
    },
  },
};

export const bloxEnglishMessages = {
  resources: {
    // Provides keys used in react-admin, but left out of ra-language-english
    user: {
      fields: {
        address: 'Address',
        department: 'Department',
        email: 'Email',
        email_placeholder: 'Enter email address',
        email_required: 'Email is required.',
        first_name: 'First Name',
        first_name_placeholder: 'Enter first name',
        last_name: 'Last Name',
        last_name_placeholder: 'Enter last name',
        municipality: 'Municipality',
        password: 'Password',
        phone: 'Phone',
        postal_code: 'Postal Code',
        screen_name: 'Screen Name',
        title: 'Title',
      },
    },
    transactions: {
      name: 'Transactions',
      fields: {
        transactions_search: 'All Transactions',
      },
    },
  },
  blox: {
    logs: {
      search_placeholder: 'Search log messages...',
      level: 'Level',
      date_range: 'Date range',
      details: {
        title: 'Log entry',
        time: 'Time',
        status: 'Status',
        driver: 'Driver',
        level: 'Level',
        message: 'Message',
        fields: 'Details',
        no_message: 'No message.',
        copy_message: 'Copy message',
        copy_value: 'Copy value',
      },
      levels: {
        debug: 'Debug',
        info: 'Info',
        warning: 'Warning',
        notice: 'Notice',
        error: 'Error',
        fatal: 'Fatal',
      },
      error: {
        failed_to_load: 'Failed to load logs.',
      },
    },
    ai_chat: {
      label: 'AI Chat',
      try_asking: 'Try asking...',
      need_any_help: 'Need any help?',
      assistant_name: 'BLOX Digital Assistant',
      input_placeholder: 'Ask a question...',
      send_message: 'Send message',
      clear_messages: 'Clear all messages, files, and reset the conversation context',
      stop_generating: 'Stop generating',
      beta_program: 'This feature is currently in beta.',
      ai_warning: 'AI can make mistakes, please verify important information.',
      untitled_file: 'Untitled file',
      attach_files: 'Attach files',
      attached_files: 'Attached files',
      files_context:
        'These files will be included as additional context for the assistant.',
      files_supported: 'Files supported: {{types}}.',
      max_files: 'Maximum of {{max}} files can be attached.',
      unsupported_files: 'Unsupported file(s): {{names}}',
      files_too_large: 'File(s): {{names}} exceed max size of {{size}}.',
      file_parse_failed: 'Failed to parse file: {{name}}',
      remove_all_files: 'Remove all files',
      scroll_to_end: 'Scroll to end',
      copy_to_clipboard: 'Copy to clipboard',
      regenerate_response: 'Regenerate response',
      tools: {
        bias: {
          label: 'Bias checker',
          liberal: 'Liberal',
          leans_left: 'Leans left',
          neutral: 'Neutral',
          leans_right: 'Leans right',
          conservative: 'Conservative',
          summary: 'This article appears {{bias}} in political bias.',
        },
      },
    },
    ai: {
      search: {
        toggle_label: 'Smart Search',
        toggle_on_tooltip: 'Smart Search (Beta)',
        toggle_off_tooltip: 'Return to standard search',
        placeholder: "Describe what you're looking for…",
        submit_tooltip: 'Run Smart Search',
      },
    },
    autosave: {
      autosaved: 'autosaved',
      type_autosaved: '{{type}} autosaved',
      tooltip: {
        saved: 'Last saved {{time}}',
        autosaved: 'Changes autosaved {{time}}',
        saving: 'Changes autosaving...',
        disabled: 'Autosave is disabled',
        error: 'Autosave is disabled as the last autosave attempt failed',
        revisions: 'Autosave is disabled while viewing revisions',
        form_error: 'Autosave is disabled while the form contains errors',
        asset_disabled: 'Autosave is disabled for non-draft assets',
      },
      dialog: {
        title: 'Unsaved Changes',
        description: 'You have unsaved changes. What would you like to do?',
        actions: {
          discard: 'Discard Changes',
          save: 'Save Changes',
        },
        editorial: {
          revisions: {
            errors: {
              noRevisions: 'No revision history found.',
            },
            fields: {
              versionHistory: {
                label: 'Version History',
                options: {
                  all: 'All Users',
                  currentUser: 'Current User',
                },
              },
              search: {
                label: 'Search by comment or user email',
              },
              viewHistorically: {
                label: 'Compare Historically',
              },
              revertModal: {
                label: 'Confirm Revert',
                noComment: 'No comment provided.',
                cancel: 'Cancel',
                confirm: 'Revert to this version',
              },
            },
            notAvailableTooltip: 'Revision not available.',
            endOfResults: 'No more revisions to show.',
          },
        },
      },
      beforeUnload: 'You have unsaved changes. Are you sure you want to leave?',
    },
    actions: {
      accept: 'Accept',
      archive: 'Archive',
      add: 'Add',
      add_entry: 'Add Entry',
      new: 'New',
      apply: 'Apply',
      back: 'Back',
      cancel: 'Cancel',
      cancel_uploads: 'Cancel Uploads',
      clear_queue: 'Clear Queue',
      change: 'Change',
      clear_all: 'Clear all',
      clear: 'Clear',
      clone: 'Clone',
      close: 'Close',
      collapse: 'Collapse',
      confirm: 'Confirm',
      continue: 'Continue',
      copied: 'Copied',
      copy: {
        label: 'Copy',
        clipboard: {
          label: 'Copy {{item}} to clipboard',
          copied: '{{item}} Copied to clipboard',
        },
      },
      create: 'Create',
      crop: 'Crop',
      remove_crop: 'Remove crop',
      delete: 'Delete',
      disable: 'Disable',
      discard: 'Discard',
      download: 'Download',
      duplicate: 'Duplicate',
      enable: 'Enable',
      enter_a_value: 'Enter a value',
      export: 'Export',
      exporting: 'Exporting...',
      dropzone: 'Drag and drop files here, or click to select.',
      edit: 'Edit',
      editing: 'Editing',
      expand: 'Expand',
      expand_preview: 'Expand preview',
      failed: 'Failed',
      filter_options: 'Filter options',
      include: 'Include',
      insert_selected: 'Insert Selected',
      add_to: 'Add to...',
      keep: 'Keep',
      logout: 'Sign Out',
      load_more: 'Load More',
      loading: 'Loading...',
      maximize: 'Maximize',
      modify: 'Modify',
      next: 'Next',
      open: 'Open',
      open_in_new_window: 'Open in a new window',
      open_in_new_tab: 'Open in new tab',
      preview: 'Preview',
      publish: 'Publish',
      purge: 'Purge',
      quick_edit: 'Quick Edit',
      refresh: 'Refresh',
      reset_filters: 'Reset Filters',
      remove: 'Remove',
      remove_all: 'Remove all',
      replace: 'Replace',
      required: 'Required',
      reset: 'Reset',
      restore: 'Restore',
      retry: 'Retry',
      error_click_retry: 'An error occurred. Click to retry.',
      save: 'Save',
      saving: 'Saving',
      saved: 'Saved',
      save_close: 'Save and Close',
      save_reload: 'Save and Reload',
      save_changes: 'Save Changes',
      save_draft: 'Save Draft',
      save_as_draft: 'Save as Draft',
      save_publish: 'Save and Publish',
      submit: 'Submit',
      publish_updates: 'Publish Updates',
      select_action: 'Select action',
      search: 'Search',
      select: 'Select',
      select_all: 'Select All',
      select_all_prompt: 'Would you like to select all?',
      set_as_preview: 'Set as preview',
      set_as_teaser: 'Set as teaser',
      set_as_cover_art: 'Set as cover art',
      start_listening: 'Start listening',
      stop_listening: 'Stop listening',
      success: 'Success',
      show: 'Show',
      undo: 'Undo',
      undo_deletion: 'Undo deletion',
      restore_success: 'Restore successful',
      restore_requested: 'Restore requested',
      unpin: 'Unpin',
      unlock: 'Unlock',
      use_selected: 'Use Selected',
      update: 'Update',
      upload: 'Upload',
      uploading: 'Uploading',
      view: 'View',
      fetching: 'Fetching',
      copy_to_site: 'Copy to Site...',
    },
    copy_to_site: {
      target_sites_label: 'Target sites',
      site_select: 'Select destination sites',
      please_select_sites: 'Please select sites to continue',
      no_target_sites:
        'No other sites available. You are currently on {{site}}, which is the only site you have access to.',
      processing_progress: 'Processing {{count}} sites... {{progress}}',
      site_header: 'Site',
      status_header: 'Status',
      summary: 'Successfully copied to {{success}} of {{total}} sites.',
      summary_error: '{{error}} sites were not compatible.',
      confirm_close_title: 'Are you sure you want to close?',
      confirm_close_content: 'Any copies not yet processed will be skipped.',
      confirm_proceed_title: 'Are you sure you want to proceed?',
      retryable_errors_summary: '{{count}} sites failed to process',
    },
    errors: {
      generic: 'Something went wrong.',
    },
    permissions: {
      msg: {
        // helper messages
        required_short: 'Requires {{name}} permission',
        required_long: 'Your account requires permission to {{name}}',
        required_list_short: 'Requires {{names, list}} permissions',
        required_list_long: 'Your account requires permissions to {{names, list}}',
        access_restricted: 'Access Restricted',
        contact_admin:
          'Contact your system administrator to request the necessary permissions for your account.',
      },
      // see permissions.ts for details
      site_admin: 'site admin',
      full_access: 'full access',
      editorial: 'editorial',
      editorial_settings: 'editorial settings',
      syndication: 'syndication',
      create_assets: 'create assets',
      modify_assets: 'modify assets',
      delete_assets: 'delete assets',
      change_publish_status: 'change publish status',
      batch_edit_search: 'batch edit search',
      workflows: 'workflows',
      change_workflow: 'change workflow',
      change_process: 'change process',
      site_tags: 'site tags',
      keyword_tags: 'keyword tags',
      access_rules: 'access rules',
      asset_automations: 'asset automations',
      asset_settings: 'asset settings',
      contributed_content: 'contributed content',
      related_content_styles: 'related content styles',
      content_importers: 'content importers',
      linked_sites_mapping: 'linked sites mapping',
      automated_article_export: 'automated article export',
      drm_policies: 'DRM policies',
      semantic_analysis: 'semantic analysis',
      section_maps: 'section maps',
      user: 'user',
      manage_user_accounts: 'manage user accounts',
      manage_user_groups: 'manage user groups',
      assign_user_groups: 'assign user groups',
      user_groups_not_same:
        'You must be in the same groups as the user to assign groups.',
      edit_profile: 'edit profile',
      change_avatar: 'change avatar',
      change_authentication: 'change authentication',
      override_concurrent_login_rules: 'override concurrent login rules',
      edit_custom_properties: 'edit custom properties',
      import_content: 'import content',
      modify_channels: 'modify channels',
      modify_importers: 'modify importers',
      broadcast: 'broadcast (notifier)',
      broadcast_full: 'broadcast full access',
      broadcast_change_settings: 'change broadcast settings',
      broadcast_read_notifications: 'read broadcast notifications',
      broadcast_send_notifications: 'send broadcast notifications',
      email_reach_full: 'email reach',
      access_control: 'access control',
      access_control_full: 'access control full access',
      access_control_edit_rules: 'edit access rules',
      access_control_create_rules: 'create access rules',
      access_control_delete_rules: 'delete access rules',
      access_control_modify_rules: 'modify access rules',
      access_control_settings: 'access control settings',
      subscription_any: 'subscription',
      subscription_full: 'subscription full access',
      subscription_edit: 'edit subscriptions',
      subscription_create: 'create subscriptions',
      subscription_edit_services: 'edit subscriptions services',
      subscription_service_modify: 'edit services',
      pro_data_insights_any: 'pro data insights',
      pro_data_insights_full: 'pro data insights full access',
      pro_data_insights_view_reports: 'view pro data insights reports',
      pro_data_insights_export_data: 'export pro data insights data',
      insights: {
        any: 'pro data insights',
        full: 'pro data insights full access',
        view_reports: 'view pro data insights reports',
        export_data: 'export pro data insights data',
        dashboards: {
          create: 'create custom dashboards',
          edit: 'edit custom dashboards',
          delete: 'delete custom dashboards',
          share: 'share custom dashboards',
          full: 'custom dashboards full access',
        },
      },
    },
    framework: {
      user_menu: {
        theme: 'Theme',
        theme_description:
          'Select your global display preference for the interface. Choose between a dark or light theme to suit your visual comfort and working environment. This setting will apply across the entire platform, ensuring a consistent appearance whenever you access your tools and content.',
        theme_options: {
          light: 'Light',
          dark: 'Dark',
          browser: 'Browser (requires refresh)',
        },
        dark_mode: 'Dark Mode',
        language: 'Language',
        language_description:
          'Choose your preferred language for the interface. This preference is used for your account and can be changed at any time.',
        tooltip: 'Profile',
        view_site: {
          label: 'Site Preview',
          front: 'View front page',
          front_anon: 'View front page anonymously',
          time_preview: 'View time-specific front page preview',
          preview: 'View front page preview',
        },
        tracking: 'Session Tracking',
        tracking_description:
          'Choose whether session tracking is enabled for your account experience. This preference can be updated at any time.',
        my_preferences: 'My Preferences',
        preferences: {
          global: {
            label: 'Global Preferences',
          },
          site: {
            label: 'Site Preferences',
          },
          set_title: 'Set {{screen}}',
          save_success: 'Preferences saved successfully.',
          save_error: 'Error saving preferences.',
          loading: 'Loading preferences...',
          notifications: {
            label: 'Notifications and Alerts',
          },
          default_asset_settings: {
            label: 'Default Asset Settings',
          },
          start_time: {
            label: 'Default asset start time',
            title: 'Set default asset start time',
            specify_time: 'Specify Start Time',
            description:
              'Use this preference to set the default start time to use for all new assets you create. This preference will last only for the duration of your session. After logging out and logging back in the system will revert to using the current date and time until you set this preference again.',
            radio_current: 'Set start time to the current date and time',
            radio_specific: 'Set start time to a specific date and time',
            helper_text:
              'Publication date is currently using your set start time in settings.',
            invalid: 'Invalid start time',
          },
          workflow: {
            label: 'Default asset workflow',
            title: 'Set default asset workflow',
            input_label: 'Workflow',
            none: 'Select a default workflow',
            tooltip:
              'Workflow to automatically assign to new editorial assets you create.',
          },
          author: {
            label: 'Default asset author',
            title: 'Default asset author',
            description: 'Automatically set yourself as the author of assets you create?',
          },
          presentations: {
            title: 'Default Presentations',
            description:
              'Choose the presentation mode applied to new assets you create, by type. This is a personal preference and does not affect other users. New assets inherit the selected mode unless it is overridden on the asset. The default is None.',
            none: 'None',
          },
        },
      },
      card_view: {
        grid: 'Grid View',
        list: 'List View',
        summary: 'Summary View',
        preview: 'Preview',
      },
    },
    assistant: {
      label: 'Assistant',
      score: {
        label: 'Optimization Score',
        low: 'Low',
        medium: 'Medium',
        high: 'High',
      },
      content: {
        label: 'Content Assistant',
        actions: {
          select: 'Select an action',
          complete: 'Complete',
          emojify: 'Emojify',
          extend: 'Extend',
          rephrase: 'Rephrase',
          shorten: 'Shorten',
          simplify: 'Simplify',
        },
      },
      keyword: {
        label: 'Keyword Assistant',
      },
      seo: {
        title: {
          label: 'SEO Title Assistant',
        },
        description: {
          label: 'SEO Description Assistant',
        },
      },
      social_title: {
        label: 'Social Title Assistant',
      },
      social_summary: {
        label: 'Social Summary Assistant',
      },
      summary: {
        label: 'Summary Assistant',
      },
      url_title: {
        label: 'URL Title Assistant',
      },
      suggestion: {
        label: 'AI Suggestion',
        current: 'Current',
        suggested_replacements: 'Suggested Replacements',
        dismiss: 'Dismiss',
        rules: {
          spell_check: {
            title: 'Spelling',
            prompt: 'Identify and correct any spelling mistakes',
          },
          grammar_check: {
            title: 'Grammar',
            prompt: 'Identify and correct any grammar mistakes',
          },
        },
      },
    },
    batch_edit: {
      label: 'Batch Edit',
      actions: {
        edit: 'Edit Selected',
        edit_all: 'Batch Edit Search Results',
        clear: 'Clear Selections',
        undo_deletion: 'Undo Deletion',
        undo_deletion_help:
          'Sets the Delete Date field to remove, restoring these assets.',
      },
      confirm: {
        change_count_one: 'You are about to modify {{count}} search result.',
        change_count_other: 'You are about to modify {{count}} search result.',
        type_count: 'To confirm, please type the number of results ({{count}})',
        input_placeholder: 'Enter number of results',
        input_error: 'Number does not match total results',
      },
      help: {
        success: 'Batch edit task created',
        selectionLimited: 'Selection is limited to {{count}} items.',
        selectionExceedsLimit:
          'Please reduce your selection to {{count}} items or use the "Batch Edit Search Results" option to edit all results from your search.',
      },
      errors: {
        preflightFailed: 'Failed to load batch edit options.{{message}}',
        submitFailed: 'Failed to create batch edit task.{{message}}',
      },
    },
    batch_import: {
      importing_assets: 'Importing asset(s)',
      import_problems: 'Problem(s) with an import',
      group_label: 'Group import · {{count}} files',
      notifications: {
        bpm: {
          success_title: 'BPM Upload Complete',
          success: 'BPM File upload successful. Assets will import in the background',
          import_success_title: 'BPM Import Complete',
          import_success: 'All assets from {{fileName}} were imported successfully',
          import_success_link: 'View imported assets',
          warn_title: 'BPM Import Notice',
          warn: 'BPM file will not accept presets during import.',
          error_title: 'BPM Upload Failed',
          error: 'BPM File upload failed. Please try again.',
        },
        single_upload_title: 'File Upload Complete',
        single_upload_body: '{{fileName}} was uploaded successfully',
        single_upload_link: 'Edit {{fileName}}',
        single_upload_failed_title: 'File Upload Failed',
        single_upload_failed_body: '{{errorMessage}}',
        wire_import_success_title: 'Wire Import Complete',
        wire_import_success_body: '{{recordTitle}} was imported successfully',
        wire_import_success_link: 'Edit {{recordTitle}}',
        wire_import_failed_title: 'Wire Import Failed',
        wire_import_failed_body: '{{errorMessage}}',
        group_complete_title: 'Batch Upload Complete',
        group_complete_body_all_success: 'All {{total}} files uploaded successfully',
        group_complete_body_partial:
          '{{success}} of {{total}} files uploaded successfully. Failed: {{failedFiles}}',
        group_complete_body_all_failed: 'All {{total}} files failed to upload',
        group_complete_link: 'View imported files',
        // Legacy keys — retained for backward compatibility
        group_complete: '{{success}} of {{total}} files uploaded successfully',
        single_success: 'File uploaded successfully.',
        // Fallback notify messages (used when user notifications are disabled)
        notify_import_complete: 'Import of {{fileName}} complete.',
        notify_import_update_complete: 'Import of {{fileName}} update complete.',
        notify_import_failed: 'Import of {{fileName}} failed.',
        notify_upload_failed: 'Upload Failed: {{errorMessage}}',
        notify_missing_binary_id: 'Upload Failed: Missing binary ID in response.',
        notify_upload_canceled: 'Upload canceled by user.',
        notify_record_already_imported:
          'Record already imported, redirecting to edit page',
        notify_import_in_progress: 'Import already in progress',
        notify_record_imported: 'Record imported successfully',
        notify_record_importing: 'Record importing',
        notify_wire_import_failed: 'Import Failed: Unable to import wire asset',
        notify_wire_import_error: 'Error during import: {{errorMessage}}',
      },
      columns: {
        upload_status: 'Upload Status',
        file_name: 'File Name',
      },
      presets: {
        label: 'Presets',
      },
    },
    export: {
      label: 'Export',
      msg: {
        export_success: 'Export task created successfully',
        export_ready: 'Export file is ready for download',
        export_error: 'Failed to create export task',
        download_success: 'Export file downloaded successfully',
        download_error: 'Failed to download export file',
      },
    },
    import: {
      label: 'Import',
      files: {
        import_success: 'Imports successfully',
        import_error: 'An error occured with imports',
        upload_success: 'Import file uploaded successfully',
        upload_error: 'Failed to upload import file',
      },
      assets: {
        imported: 'Assets Imported',
      },
    },
    business: {
      label: 'Business',
    },
    staticpages: {
      label: 'Static Pages',
    },

    subscription: bloxEnglishSubscriptionMessages,
    transactions: bloxEnglishSubscriptionMessages.transactions,
    giftSubscription: {
      label: 'Gift Subscriptions',
      noResults: 'No gift subscriptions available.',
      loading: 'Loading Gift Subscriptions...',
      loadingDetails: 'Loading gift subscription details...',
      loadMore: 'Load More',
      loadingMore: 'Loading...',
      retry: 'Retry',
      errorLoadingGiftSubscriptions:
        'Unable to load gift subscriptions. Please try again.',
      purchased: 'Purchased {{date}}',
      toRecipient: 'To: {{email}}',
      redeemed: 'Redeemed {{date}}',
      close: 'Close',
      status: {
        redeemed: 'Redeemed',
        notRedeemed: 'Not Redeemed',
      },
      detail: {
        loadingHeader: 'Loading gift details...',
        redeemedBy: 'Redeemed by',
        viewRecipientProfile: 'View recipient profile',
        notRedeemed: 'Not Redeemed',
        giftDetails: 'Gift Details',
        rateName: 'Rate Name',
        rate: 'Rate',
        termExpires: 'Term Expires',
        termExpired: 'Term Expired',
        subscriptionStart: 'Subscription Start',
        giftCode: 'Gift code',
        purchaseDate: 'Purchase date',
        deliveryDate: 'Delivery date',
        redeemedDate: 'Redeemed date',
        purchaser: 'Purchaser',
        purchaserName: 'Purchaser Name',
        recipient: 'Recipient',
        region: 'Region',
        postalCode: 'Postal code',
        country: 'Country',
        recipientName: 'Recipient Name',
        email: 'Email',
        deliveryAddress: 'Delivery Address',
        deliveryMunicipality: 'Delivery Municipality',
        deliveryRegion: 'Delivery Region',
        deliveryPostalCode: 'Delivery Postal code',
        deliveryCountry: 'Delivery Country',
        deliveryPhone: 'Delivery Phone',
        transaction: 'Transaction',
        transactionDate: 'Transaction Date',
        amount: 'Amount',
        duration: 'Duration',
        transactionId: 'Transaction ID',
        price: 'Price',
        taxRate: 'Tax Rate',
      },
    },

    user: {
      label: 'Users',
      title: 'User Profile',
      unknown_user: 'Unknown User',
      account_type: {
        admin: 'Admin',
        normal: 'Normal',
        any: 'Any',
      },
      actions: {
        sending: 'Sending...',
        send_password_reset: 'Send password reset',
        send_instant_login: 'Send instant login',
        send_admin_invite: 'Send Admin Invite',
        invite_to_site: 'Invite to Site...',
        reset_password: 'Reset Password',
        instant_login: 'Instant Login',
        set_password: 'Set Password',
        edit_profile: {
          label: 'Edit Profile',
          title: 'Editing User Profile',
        },
        edit_user: {
          title: 'Editing User',
          title_admin: 'Editing Admin User',
        },
        edit_groups: {
          title: 'Groups',
          submit_success: 'Groups updated',
          errors: {
            min: 'Please select at least one group.',
          },
        },
        change_password: {
          name: 'Password',
          label: 'Change Password',
          label_alt: 'Enter Password',
          help: 'Password must be at least {{minLength}} characters long.',
          placeholder: 'New password',
          confirm_placeholder: 'Confirm new password',
          password_mismatch: 'Passwords do not match',
          required: 'Password is required.',
          success: 'Password updated successfully',
          error: 'Failed to update password',
          user_option: 'Allow user to set own password',
          user_option_help:
            'Enable this option to send a password reset email to the user, allowing them to securely set their own password after creation.',
        },
        viewUser: 'View Public Profile',
        auth_group: 'Account Security',
        user_settings: {
          label: 'User Admin Settings',
        },
        admin_invite: {
          submit_success: 'Administrator invitation email sent successfully',
          submit_error: 'Failed to send administrator invitation email',
          email_validation: {
            error: 'Failed to validate email',
            error_groups: 'Please select at least one group.',
          },
          form: {
            create_note:
              'An admin invite email will be sent with an account created upon acceptance.',
            sending_to: 'Sending an admin invite email to',
            email_label: 'Email',
            email_placeholder: 'Enter email address',
            select_groups: 'Select groups in which to enroll this user.',
          },
        },
        downgrade: {
          label: 'Remove Admin Privileges',
          title: 'Remove Admin Privileges for {{user}}',
          description:
            'This action will remove admin privileges from this user. They will no longer have access to admin features and settings.',
          warning: 'Are you sure you want to downgrade this user?',
          confirm_msg:
            'Are you sure you want to downgrade this user to a normal account?',
          confirm_btn: 'Yes, Remove Admin Privileges',
          submit_success: 'Administrator has been downgraded',
          submit_error: 'Failed to send administrator downgrade request',
        },
      },
      avatar: {
        label: 'Avatar',
        remove: 'Remove Avatar',
        max_size_err: 'File size exceeds maximum of 5mb.',
        invalid_format:
          'Invalid file format. Please upload an image file (jpg, png, gif).',
        uploading: 'Uploading...',
        upload_success: 'Avatar updated successfully',
        upload_error: 'Failed to update avatar. Please try again.',
        drop_image_here: 'Drop an image here, or click to select a file',
        drag_to_replace: 'Drag & drop to replace avatar',
        drag_to_upload: 'Drag & drop an avatar image here',
        click_browse: 'or click to browse',
        formats: 'JPG, PNG, or GIF (max 5MB)',
      },
      msg: {
        instant_login_success: 'Instant login email sent',
        instant_login_error: 'Failed to send',
        password_reset_success: 'Password reset email sent successfully',
        password_reset_error: 'Failed to send',
      },
      activity_stream: {
        label: 'Activity Stream',
        loading: 'Loading activity stream data...',
        refreshing: 'Refreshing...',
        error: 'Error loading activity stream data.',
        no_results: 'No activity stream data available.',
        end_results: 'No more activity stream data available.',
      },
      subscriptions: {
        no_results: 'No subscriptions available.',
      },
      payment_methods: {
        label: 'Payment Methods',
      },
      linked_accounts: {
        label: 'Linked Accounts',
        no_subscriptions_to_share: 'No subscriptions available to share.',
        no_linked_accounts: 'No linked accounts available.',
        add_account: 'Add Account',
        add_linked_account: 'Add Linked Account',
        adding: 'Adding',
        add: 'Add',
        revoke: 'Revoke',
        revoking: 'Revoking...',
        revoke_access: 'Revoke Access',
        confirm_revoke_title: 'Confirm Revoke Access',
        confirm_revoke_message: 'Are you sure you want to revoke access for {{email}}?',
        user_no_subscriptions: 'User has no subscriptions',
        email_prompt: 'Enter the email address of the account you want to link.',
        view_user_in_new_tab: 'View user in a new tab',
        granted: 'Granted',
        invited: 'Invited',
        status_in: '{{status}} in {{date}}',
        granted_access_to: 'Granted access to {{email}} in {{date}}',
        linked_subscription_inactive: 'Linked account subscription inactive',
        grantor_subscription_inactive: 'Grantor subscription inactive',
      },
      audiences: {
        label: 'Audiences',
        loading: 'Loading user audiences...',
        error: 'Error fetching audiences. Please try again.',
        no_user_id: 'No user ID provided.',
        no_description: 'No description available.',
        view_description_aria: 'View description for {{label}}',
        dmp_unavailable:
          'Behavioral data tracking is currently unavailable for this profile as your site does not have the CDP/DMP activated. Please contact your site administrator to discuss enabling this feature.',
        no_audiences: 'No audiences available.',
      },
      search: {
        action: 'Search user accounts...',
        loading: 'Loading User Search...',
        user_account: 'User Account',
        admin_account: 'Admin Account',
        multisite: {
          title: 'Contacts / Multi-Site Search',
          help: 'Search to view user accounts across multiple sites.',
        },
        admin: {
          action: 'Search admin accounts...',
        },
      },
      groups: {
        label: 'Groups',
        no_groups: 'No groups available.',
        edit_groups: 'Edit Groups',
        copy: {
          label: 'Copy Groups to Site',
          fetching_groups: 'Fetching group data...',
          groups_to_copy: 'Groups to copy ({{count}})',
          group_fallback_name: 'Group {{id}}',
          members_count_one: '{{count}} member',
          members_count_other: '{{count}} members',
          name_too_long: 'Group name must be 100 characters or fewer',
          count_with_word: '{{count}} {{word}}',
          group_word_one: 'group',
          group_word_other: 'groups',
          site_word_one: 'site',
          site_word_other: 'sites',
          summary_copied_part: '{{groupCountText}} copied to {{siteCountText}}',
          summary_error_part: '{{siteCountText}} with errors',
          row_groups_copied_one: '{{count}} group copied',
          row_groups_copied_other: '{{count}} groups copied',
          row_groups_failed_one: '{{count}} group failed to copy',
          row_groups_failed_other: '{{count}} groups failed to copy',
          confirm_copy_header: 'Confirm Copy Groups',
          confirm_copy_sub_text_one: 'Copy groups to {{count}} site.',
          confirm_copy_sub_text_other: 'Copy groups to {{count}} sites.',
          confirm_copy_sub_text_all: 'Copy groups to all sites.',
          confirm_copy_button: 'Yes, Copy',
        },
        form: {
          groupDetails: 'Group Details',
          assignedCapabilities: 'Assigned Capabilities',
          noCapabilities: 'No capabilities defined',
          addCapabilityModalTitle: 'Add Capability',
          totalCapabilities: 'Total Capabilities',
          removeCapability: 'Remove capability',
          addCapability: {
            label: 'Add Capability',
            apps: 'Apps',
            additionalOptions: 'Additional Options',
            preview: 'Preview',
            noSelection: 'No capabilities selected',
            noOptionsSelected: 'No options selected',
            editOptions: 'Edit options',
          },
          create: {
            success: 'Group created',
            error: 'Error creating group',
            title: 'Create New Group',
            selectedCapabilities: 'Selected Capabilities',
          },
          edit: {
            title: 'Edit Group',
          },
          name: {
            required: 'Group name is required',
            label: 'Group Name',
            placeholder: 'Enter group name',
          },
          members: {
            label: 'Members',
          },
        },
      },
      profile_information: {
        label: 'Profile Information',
        edit_profile: 'Edit Profile',
        about: 'About',
        topic_focus: 'Topic Focus',
        location_focus: 'Location Focus',
        demographic_focus: 'Demographic Focus',
        languages: 'Languages',
        memberships: 'Memberships',
        awards: 'Awards',
        also_available: 'Also Available',
        no_information: 'No profile information available.',
        edit_field_tooltip: "Enter the user's {{field}}",
        update_success: 'Profile updated successfully',
        update_error: 'Error updating profile',
      },
      fields: {
        location: 'Location',
        birthday: 'Birthday',
        country: 'Country',
        region: 'Region',
        facebook: 'Facebook',
        linkedin: 'LinkedIn',
        x: 'X',
        social_url_tooltip: 'URL for {{account}} account',
      },
      sections: {
        details: 'Details',
        addresses: 'Additional Addresses',
        byline: 'Byline',
        tagline: 'Tagline',
        personal_info: 'Personal Information',
        address_info: 'Address Information',
        professional_info: 'Professional Information',
        admin_info: 'Admin Information',
        social_info: 'Social Media',
      },
      empty: {
        address: 'No address provided',
      },
      meta: {
        created: 'Joined',
      },
      settings: {
        admins: {
          label: 'Admins',
          manage: 'Manage Admins',
          groups: 'Groups',
          invite: 'Invite Admin',
        },
      },
      quick_filters: {
        label: 'Quick Filters',
        no_saved_searches: 'No quick filters.',
        columns: {
          name: 'Name',
          application: 'Application',
        },
      },
      invite_to_site: {
        title: 'Invite to Site',
        button_label: 'Invite to Site...',
        send_button: 'Send Invites',
        groups_label: 'Groups to assign ({{count}} selected)',
        users_to_invite: 'Users to invite ({{count}})',
        select_groups_error: 'Please select at least one group',
        groups_help_text:
          'Any groups that do not exist on the target site will be created.',
        search_groups_placeholder: 'Search groups...',
        selected_groups_one: '{{count}} selected',
        selected_groups_other: '{{count}} selected',
        no_groups_match: 'No groups match your search',
        group_ensure_error: 'Failed to ensure group "{{group}}" on {{domain}}: {{error}}',
        invite_error: 'Failed to invite {{email}} to {{domain}}: {{error}}',
        summary_success_one: '{{count}} user invited to {{siteCountText}}',
        summary_success_other: '{{count}} users invited to {{siteCountText}}',
        summary_partial_success_one: '{{count}} user invited to {{siteCountText}}',
        summary_partial_success_other: '{{count}} users invited to {{siteCountText}}',
        site_count_one: '{{count}} site',
        site_count_other: '{{count}} sites',
        row_users_invited_one: '{{count}} user invited',
        row_users_invited_other: '{{count}} users invited',
        row_users_failed_one: '{{count}} failed',
        row_users_failed_other: '{{count}} failed',
        row_invite_failed_one: '{{count}} invite failed',
        row_invite_failed_other: '{{count}} invites failed',
        row_groups_failed_one: '{{count}} group not compatible',
        row_groups_failed_other: '{{count}} groups not compatible',
        group_not_added: 'Group not compatible: {{group}}',
        confirm_close_title: 'Are you sure you want to close?',
        confirm_close_content: 'Any invites not yet processed will be skipped.',
        confirm_invite_header: 'Confirm Invite',
        confirm_invite_sub_text_one: 'Invite users to {{count}} site.',
        confirm_invite_sub_text_other: 'Invite users to {{count}} sites.',
        confirm_invite_sub_text_all: 'Invite users to all sites.',
        confirm_invite_button: 'Yes, Invite',
      },
    },
    adowl: {
      label: 'Ad Owl',
    },
    calendar: {
      label: 'Calendar',
    },
    classifieds: {
      label: 'Classifieds',
    },
    eedition: {
      label: 'e-Editions',
    },
    electionsstats: {
      label: 'Election Stats',
    },
    email: {
      label: 'Email',
    },
    form: {
      label: 'Form',
    },
    html: {
      label: 'HTML',
    },
    search: {
      label: 'Search',
      placeholder: 'Search content...',
      runtime: 'Runtime',
      actions: {
        return: 'Back to Search',
        returnAlt: 'Return to search results',
      },
      view: {
        card_view: 'Card view',
        list_view: 'List view',
        summary_view: 'Summary view',
      },
      sort: {
        label: 'Sort',
        sorted: 'Sorted',
        sorted_label_dir: 'Sorted: {{label}} ({{direction}})',
        ascending: 'Ascending',
        descending: 'Descending',
        remove_sort: 'Remove sort',
      },
      // saved search / quick filters
      saved: {
        shared_with_org: 'Shared with organization',
        shared: 'Shared',
        quick_filters: 'Quick filters',
        saved_filters: 'Saved filters',
        my_filters: 'My filters',
        shared_filters: 'Shared filters',
        create_new_filter: 'Create new filter',
        applied_filter: 'Applied filter',
        new_quick_filter: 'New quick filter',
        new_quick_filter_desc: 'Save the current search criteria as a quick filter.',
        replace_quick_filter: 'Replace quick filter',
        replace_quick_filter_desc:
          'Replace an existing quick filter with the current search criteria.',
        quick_filter_name: 'Quick filter name',
        for_working_privately: 'For working privately',
        for_share_with_org: 'For sharing with your organization',
        save_quick_filter: 'Save quick filter',
        edit_quick_filter: 'Edit quick filter',
        delete_success: 'Quick filter deleted successfully.',
        delete_confirm: '"{{name}}" will be deleted.',
        this_quick_filter: 'This quick filter',
        default_modal: {
          title: {
            remove: 'Remove Default',
            replace: 'Replace Default',
            confirm: 'Confirm Default',
          },
          content: {
            remove: 'Confirm removal of <b>{{name}}</b> as default search?',
            replace:
              'Replace <b>{{currentName}}</b> with <b>{{newName}}</b> as default search?',
            set: 'Set <b>{{name}}</b> as default search?',
          },
          actions: {
            cancel: 'Cancel',
            confirm: 'Confirm',
          },
        },
      },
      batch: {
        label: 'Batch edit search results',
      },
      multisite: {
        domains: {
          label: 'Domains',
          action: 'Select domains',
          help: 'Domains selected',
          filter: 'Search domains...',
          all: 'All Sites',
        },
      },
      table: {
        last_modified_by: 'Last Modified By',
        owner: 'Owner',
        default: 'Default',
        categories: 'Categories',
        uuid: 'UUID',
        created_date: 'Created Date',
        domain: 'Domain',
        subscription_state: 'Subscription State',
        term: 'Term',
        services: 'Services',
        rate_name: 'Rate Name',
        term_expires: 'Term Expires',
        service_icon: 'Service Icon',
        service_title: 'Service Title',
        service_type: 'Service Type',
        active_subscribers: 'Active Subscribers',
        new_subscribers: 'New Subscribers',
        stopped_subscribers: 'Stopped Subscribers',
        payment_handler: 'Payment Handler',
        service_id: 'Service ID',
        author: 'Author',
        created: 'Created',
        actions: 'Actions',
        search_templates: 'Search templates...',
      },
    },
    asset_library: {
      label: 'Asset Library',
      action: {
        drag: 'Drag and drop assets from the asset library.',
      },
    },
    editorial: {
      label: 'Editorial',
      loading: 'Loading editorial...',
      help: {
        no_access: 'Modify assets permission required',
      },
      infobar: {
        status: 'Status',
        online: 'Online',
        published: 'Published',
        unpublished: 'Unpublished',
        offline: 'Offline',
        revision: 'Rev',
        access: 'Access',
        expires: 'Expires',
        workflow: 'Workflow',
        title: 'Title',
        words: 'Words',
        characters: 'Chars',
        web: '(Web)',
        words_print: 'Words (Print)',
        depth: 'Depth',
        images: 'Images',
        rich_media: 'Media',
        new: 'New',
        draft: 'Draft',
        live: 'Live',
        yes: 'Yes',
        no: 'No',
        default: 'Default',
        scheduled: 'Scheduled',
        rev_no_live: 'This asset is published with no live revision.',
        rev_not_loaded: 'N/A',
        rev_not_loaded_tip:
          'This asset was published more than 100 revisions ago. Check the revision history for details.',
      },
      batchImport: {
        label: 'Batch Upload',
      },
      templates: {
        newStory: 'New Story',
        createMenu: {
          heading: 'Story Templates',
          empty:
            'No story templates yet. Create one to reuse its structure and metadata.',
          error: 'Unable to load story templates.',
          createFromAria: 'Create from template: {{title}}',
          untitled: 'Untitled Template',
        },
      },
      assetQuickLaunch: {
        createTitle: 'Create {{label}}',
        createAction: 'Create {{label}}',
        duplicateTitle: 'Duplicate {{label}}',
        duplicateAction: 'Duplicate {{label}}',
        templateTitle: 'Save as {{label}} Template',
        createTemplateTitle: 'New {{label}} Template',
        templateAction: 'Create Template',
        template: {
          nameLabel: 'Template Title',
          nameHelp: 'Optional — falls back to existing title',
          nameHelpNew: 'Optional — you can rename the template later',
        },
        useTemplate: {
          title: 'Create {{label}} from Template',
          action: 'Create {{label}}',
        },
        apply: {
          warning_duplicate: 'Unable to apply quick launch values to duplicate.',
        },
        workflows: {
          error:
            'Unable to load workflows right now. You can try again or continue without a workflow.',
        },
        workflow: {
          label: 'Workflow',
          helper: 'Optional — falls back to site defaults.',
          untitled: 'Untitled Workflow',
        },
        startTime: {
          label: 'Start Time',
          helper: 'Optional — saved in {{timeZone}}.',
        },
        slug: {
          label: 'Slug',
          placeholder: 'Enter a slug',
          helper: 'Optional — pre-fills the print slug on the asset.',
          helper_duplicate: 'Optional — leave blank to auto-generate from headline.',
        },
        storyTemplate: {
          label: 'Story Template',
          helper:
            'Select a template to pre-fill the asset with pre-defined content and metadata.',
          blank: 'Blank',
          error:
            'Unable to load story templates right now. You can continue with a blank asset.',
        },
      },
      asset: {
        // Save messaging...
        created: '{{type}} created',
        updated: '{{type}} updated',
        saved: '{{type}} saved',
        saved_draft: '{{type}} saved as draft.',
        workflow_updated: 'Workflow updated',
        workflow_process_updated: 'Workflow process updated',
        confirm_publish: 'Confirm and Publish',
        confirm_demotion: 'Confirm Demotion',
        confirm_demotion_and_publish: 'Confirm Demotion and Publish',
        confirm_promotion: 'Confirm Promotion',
        confirm_promotion_and_publish: 'Confirm Promotion and Publish',
        promote_to: 'Promote to',
        demote_to: 'Demote to',
        promote_and_publish_to: 'Promote and Publish to',
        demote_and_publish_to: 'Demote and Publish to',
        published_draft: 'Status is draft and published.',
        published_live: 'Status is live and published.',
        unpublished_draft: 'Status is draft and unpublished.',
        unpublished_live: 'Status is live and unpublished.',
        dates_updated: 'Dates updated',
        archive_date_updated: 'Archive date updated',
        delete_date_updated: 'Delete date updated',
        archive_and_delete_updated: 'Archive and delete dates updated',
        // Asset fields
        title: {
          label: 'Headline',
          label_alt: 'Title',
          help_alt: 'Enter a title...',
          help_alt_poll: 'Enter a question...',
        },
        byline: {
          label: 'Byline',
          help: 'Enter a byline...',
        },
        caption: {
          label: 'Caption',
          help: 'Enter a caption...',
          description: 'Drop a new caption file to add another format',
          supported_formats: 'Supported formats: WebVVT (.vtt), SubRip (.srt)',
          invalid_format: 'The URL does not end in .vtt or .srt',
        },
        content: {
          label: 'Content',
        },
        content_characters: {
          label: 'Content Characters',
        },
        cover: {
          label: 'Cover Art',
          description: 'Upload a cover art image for display in article design.',
          properties: {
            label: 'Cover Art Display Properties',
            description: 'Set the display properties for the cover art',
            cover_img: {
              label: 'Cover Art Image',
              help: 'Drag and drop or click in the area above to upload a new cover image',
              invalid: 'The URL does not end in .jpeg, .jpg, .png, .gif, .tiff, or .bmp',
            },
            cover_align_horizontal: {
              label: 'Text horizontal alignment',
              options: {
                center: 'Centered',
                left: 'Left',
                right: 'Right',
              },
            },
            cover_align_vertical: {
              label: 'Text vertical alignment',
              options: {
                top: 'Top',
                middle: 'Middle',
                bottom: 'Bottom',
              },
            },
            cover_text_color: {
              label: 'Text color',
              options: {
                light: 'Light',
                dark: 'Dark',
              },
            },
            cover_text_background: {
              label: 'Text background',
              options: {
                none: 'None',
                background_box: 'Background box',
                text_in_a_box: 'Text-in-a-box',
              },
            },
            cover_effect: {
              label: 'Effect',
              options: {
                none: 'None',
                parallax: 'Parallax',
                ken_burns: 'Pan and zoom',
                blur: 'Blur',
                grayscale: 'Grayscale',
                sepia: 'Sepia',
                desaturate: 'Desaturate',
              },
            },
          },
        },
        tagline: {
          label: 'Tagline',
        },
        address: {
          label: 'Address',
        },
        municipality: {
          label: 'City or municipality',
        },
        postal_code: {
          label: 'Postal Code (ZIP)',
        },
        country: {
          label: 'Country',
        },
        region: {
          label: 'Region',
        },
        related_content: {
          label: 'Related Content',
          relationships_label: 'Relationships',
          actions: {
            insert: {
              label: 'Create and insert Related Content',
            },
            add: {
              label: 'Add to relationships',
              label_specific: 'Add to {{relationship}}',
            },
            view_selected: 'View Selected',
            close_selected: 'Close Selected',
            unselect_all: 'Unselect all items',
            remove: {
              label: 'Remove selected assets',
              confirm: 'Confirm Removal',
              help_one:
                'Are you sure you want to remove {{count}} related item from this asset?',
              help_other:
                'Are you sure you want to remove {{count}} related items from this asset?',
              warn: 'Cannot remove inline assets',
              note: 'Note: Items cannot be removed while inline.',
            },
            search: {
              label: 'Search related content...',
            },
            move_to_top: 'Move to Top',
            move_to_bottom: 'Move to Bottom',
          },
          table: {
            type: 'Type',
            title: 'Title',
            start_date: 'Start Date',
            status: 'Status',
          },
          aria_labels: {
            drag_handle: 'Drag to reorder',
            more_options: 'More options',
          },
          moving: 'Moving...',
          notifications: {
            added: 'Added {{count}} to {{relationship}}.',
            added_with_duplicates:
              'Added {{count}} to {{relationship}}. (Duplicates: {{duplicates}})',
            all_duplicates: 'All selected items were already in {{relationship}}.',
          },
          help: {
            no_selection: 'No items selected',
          },
          parents: {
            label: 'Parents',
          },
          siblings: {
            label: 'Siblings',
          },
          related_content: {
            label: 'Content',
          },
        },
        latitude: {
          label: 'Latitude',
        },
        longitude: {
          label: 'Longitude',
        },
        archive_time: {
          label: 'Archive Date',
        },
        delete_time: {
          label: 'Delete Date',
        },
        files: {
          label: 'Files',
          social: {
            label: 'Social Preview Image',
          },
        },
        flags: {
          label: 'Flags',
        },
        keywords: {
          label: 'Keywords',
          help: 'Search or add keywords',
          not_found: 'No results found. Press enter to add.',
          caption:
            'Assign keywords to improve how your video is discovered across websites, apps, and feeds. These keywords help match your video to relevant searches.',
        },
        site_tags: {
          label: 'Site Tags',
        },
        children: {
          label: 'Children',
          add_to_children: 'Add to Children',
        },
        parents: {
          label: 'Parents',
          add_to_parents: 'Add to Parents',
        },
        siblings: {
          label: 'Siblings',
          add_to_siblings: 'Add to Siblings',
        },
        url: {
          label: 'URL',
        },
        properties: {
          label: 'Properties',
          abuse: {
            label: 'Flagged as Abuse',
            description:
              'Indicates whether the community has collectively flagged this asset as being in violation of site policies.',
            reset_by_admin: 'reset by admin',
          },
          altext: {
            label: 'Alt Text',
            help: 'Enter alt text, for accessibility...',
          },
          article_type: {
            label: 'Type of work',
            description: 'Categorize this content based on definitions from schema.org.',
            placeholder: 'Select type of work',
          },
          app: {
            label: 'Source Application',
            help: 'Read-only',
          },
          canonical_url: {
            label: 'Canonical URL',
            description:
              'The fully qualified canonical URL for this asset. Primarily useful if the content originated from a third party source. URLs must contain a protocol, host, and path to be considered fully qualified.',
          },
          custom: {
            label: 'Custom Properties',
            name: {
              label: 'Name',
              help: {
                spaces: 'No spaces allowed',
                unique: 'Name must be unique',
                required: 'Name is required',
              },
            },
            value: {
              label: 'Value',
              help: {
                required: 'A value is required',
              },
            },
          },
          external_id: {
            label: 'Imported CMS ID',
            help: 'Read-only',
          },
          hammer: {
            label: 'Hammer',
          },
          kicker: {
            label: 'Kicker',
          },
          subheadline: {
            label: 'Subheadline',
          },
          no_publish: {
            label: 'Do not publish',
            label_alt: 'Publish Status',
            description: 'Set publish status',

            // Remove/Restore Web Modal
            remove_from_web: 'Remove from web',
            restore_to_web: 'Restore to web',
            type_removed_from_web: '{{type}} removed from web',
            type_restored_to_web: '{{type}} restored to web',
            choose_web_version: 'Choose which version to restore to the web',
            saves_all_as_draft: 'Saves all current changes as draft',
            remove_current_version: 'Remove published version (do not publish)',
            remove_current_version_desc:
              'The asset will no longer be visible on the website',
            apply_latest_changes: 'Apply latest changes (Publish Updates)',
            apply_latest_changes_desc:
              'Saves all current changes live and publishes to the web',
            restore_prior_version: 'Restore previously published version',
            restore_prior_version_desc:
              'Restores visibility of the last published version to the web',
            controlled_by_workflow: 'This option is enforced by the workflow',
            disabled_in_create_mode: 'This option is disabled in create mode',
            disabled_in_draft: 'This option is disabled while in draft status',

            help: {
              workflow: 'Current workflow process is web ready and cannot be unpublished',
              permission: 'Change publish status permission required',
              allow: 'Ok to publish',
              disallow: 'Publish disabled',
              scheduled: 'Scheduled',
            },
          },
          no_reactions: {
            label: 'User Reactions',
            help: 'When enabled, all reaction tools (e.g., likes, emoji reactions) are available for the asset if configured on the section/page. Disabling reactions for this asset will override any site or section-level defaults.',
          },
          no_comments: {
            label: 'Commenting',
            help: 'When enabled, user commenting is available on the asset if comments are configured on the section/page. Disabling commenting for this asset will override any site or section-level defaults.',
          },
          video360: {
            label: '360° Video Mode',
            help: 'If enabled, the video will be displayed in 360 mode.',
          },
          disable_advertising: {
            label: 'Disable Advertising',
            help: 'If enabled, this setting will prevent ad tags from being applied to this video.',
            confirm_title: 'Disabling Ads Will Impact Revenue',
            warning: 'Advertising disabled. This video will play without ads.',
            confirm_description:
              'Disabling advertising for this video will prevent any ad calls and will reduce potential ad revenue. Are you sure you want to proceed?',
          },
          photo_sales: {
            label: 'Photo Sales',
          },
          priority: {
            label: 'Display Priority',
            help: 'Numbers only',
            placeholder: 'Enter a numeric priority',
          },

          seo_description: {
            label: 'SEO Description',
          },
          seo_title: {
            label: 'SEO Title',
            description: 'The title to use for SEO.',
            warning_length:
              'SEO title exceeds the recommended 60 characters for optimal SEO.',
          },
          social_title: {
            label: 'Social Title',
            description: `Alternative title to serve to social media. Defaults to the asset's primary title/headline if blank.`,
          },
          social_summary: {
            label: 'Social Summary',
            description: `Alternative summary to serve to social media. Defaults to the asset's primary summary if blank.`,
          },
          social_twitter_card: {
            label: 'Card',
            description: 'Set the card display when presented on X.',
            auto: 'Auto',
            large_image: 'Large image',
            summary: 'Summary',
          },
          url_title: {
            label: 'URL Title',
            description:
              'A consistent title to display in the URL if titles in URLs are turned on. All titles will display in the URL as lower case with only letters, numbers, spaces and dashes.',
          },

          workflow: {
            label: 'Workflow',
            current_workflow: 'Current workflow: {{workflow}}',
            default_workflow: 'Default Workflow',
            // These 3 parts make up the default workflow description
            // Split up to have cleaner css handling of typography
            default_workflow_description_p1:
              'The default workflow supports a simple Draft-to-Live publishing process. Content starts in Draft, where it can be edited freely. When ready, use Save & Publish to publish the asset to the web.',
            default_workflow_description_p2:
              'For assets that are already live, Save Draft allows you to work on updates without affecting the published version. The last live version remains visible until you select Save & Publish to publish the changes.',
            default_workflow_description_p3:
              'You can take an asset offline by selecting Remove from Web. While the asset is unpublished, changes can continue to be saved. When you are ready to make it live again, select Restore to Web to publish the updated version.',
            change_workflow_or_process: 'Change workflow or process',
            new_workflow_and_process: 'New workflow and process',
            no_workflow_assigned: 'No workflow assigned',
            no_site_workflows: 'No workflows are available for this site.',
            // Warnings for save actions
            change_warning:
              'Warning: Changing the workflow will move this asset to a different editorial process.',
            workflow_please_be_aware:
              'This asset is within a workflow, please be aware of the following.',
            process_forces_draft: 'The process will force draft.',
            process_forces_live: 'The process will force live.',
            process_resets_start_time: 'The process will reset start time.',
            process_returns_on_draft: 'The process will return on draft.',

            actions: {
              change: 'Change workflow',
              remove: 'Remove current workflow',
            },
          },

          workflow_process: {
            label: 'Process',
            current_process: 'Current process: {{process}}',
            select_process_step: 'Select process step',
            print_ready: 'Ready for print',
            web_ready: 'Ready for web',
            no_syndicate: 'Block syndication',
            reset_start_time: 'Reset start time',
            force_draft: 'Force draft',
            force_live: 'Force live',
            return_on_draft: 'Return on draft',
            disable_collaboration: 'Disable collaboration',

            help: {
              change: 'Change workflow process',
              restricted: 'Change workflow process restricted',
              promote: 'Use the Save Changes dropdown to promote through workflow steps.',
            },
          },
          publish: {
            live_view: 'Live view',
            copy_live_url: 'Copy live URL',
            help: {
              force_draft_workflow: 'The selected workflow enforces publish status',
            },
          },
        },
        update_time: {
          label: 'Last Updated',
        },
        authors: {
          label: 'Authors',
          label_one: 'Author',
          help: 'Add Authors...',
          help_reorder: 'The first author in this list is the lead.',
          primary_tooltip: 'Lead',
        },
        body_copy: {
          label: 'Body Copy',
          help: 'Enter body copy...',
        },
        creators: {
          label: 'Creators',
          help: 'Add Creators...',
        },
        description: {
          label: 'Description',
          help: 'Enter a description...',
        },
        captions: {
          label: 'Captions',
          help: 'Add Captions...',
          description:
            'Upload caption files to provide text for the hearing impaired. Supported formats include WebVTT (.vtt) and SubRip (.srt).',
          invalid_format: 'The URL does not end in .vtt, .srt, or .ttml',
        },
        video: {
          label: 'Video',
          help: 'Add Video...',
          poster: {
            label: 'Poster',
            description: 'The player poster image.',
          },
          preview: {
            label: 'Preview',
            description: 'The image displayed in the block preview.',
          },
        },
        start_time: {
          label: 'Publication Date',
          alt_label: 'Start Time',
          errors: {
            invalid: 'Invalid start time',
          },
        },
        draft: {
          label: 'Draft',
          description: 'Has unpublished changes',
        },
        source: {
          label: 'Source',
          description: "The agency which generated this asset's content.",
        },
        sections: {
          label: 'Sections',
          search_view: 'search',
          tree_view: 'tree',
          switch_view: 'Switch to {{view}} view',
          error_fetch_tree: 'Error fetching section tree',
          caption:
            'Assign section tags to guide where the video appears across you site and content feeds. These tags help the system decide where to place the video.',
          help_reorder:
            'The first section inside this list will be the primary section for this {{type}}.',
          help_drag_drop: 'Drag and drop items to reorder.',
        },
        summary: {
          label: 'Summary',
          description:
            'Enter a concise summary of your asset here. This should be a brief overview, ideally not exceeding 150-200 words, that highlights the main points or themes of the content.',
        },
        teaser: {
          label: 'Teaser Image',
          label_preview: 'Preview Image',
          description: {
            article: `Use the Teaser Image field to upload a preview image for your story. This image will  appear as a thumbnail or preview in article lists and search results. It is separate from the main content images and will not be displayed on the article's landing page. Ideal for attracting reader attention and providing a visual summary of the article's topic.`,
            image:
              'This image will appear when this asset is presented as a preview or thumbnail.',
            default: 'This image will appear as the preview or thumbnail for this asset.',
          },
        },
        type: {
          label: 'Type',
        },
        update_comment: {
          label: 'Revision Comment',
          description: 'Add a comment to this update...',
        },
        important_update: {
          label: 'Important Update',
          description: 'Mark this update as important',
        },
        presentation: {
          label: 'Presentation',
          description:
            'Select how this content should be presented to readers. Different presentation styles can help emphasize certain aspects of your content.',
        },
        poll: {
          answer: 'Answer',
          answers: 'Answers',
          add_answer: 'Add Answer',
          add_answer_desc: 'Press the "Add Answer" button to add choices.',
          remove_choice: 'Remove Choice',
          votes: 'Votes',
          color: 'Color',
          bar_graph: 'Bar Graph',
          pie_chart: 'Pie Graph',
          total_votes: 'Total Votes',
        },
      },
      collab: {
        disconnected: 'Disconnected',
        disconnect_warning:
          'Please check your internet connection, as you appear to be disconnected or offline.',
        sessions: 'Sessions',
        current_session: 'Current session',
        other_sessions: 'Other sessions',
        no_other_sessions: 'No other sessions',
        collaborators: 'Collaborators',
        no_other_collaborators: 'No other collaborators',
      },
      metadata: {
        group: {
          uuid: {
            label: 'UUID',
          },
          workflow: {
            label: 'Workflow',
            help: {
              restricted: 'Access restricted for this workflow',
              reset_start_time:
                'Publication Date is reset to "Now" by the assigned workflow process',
            },
          },
          dates: {
            label: 'Dates',
          },
          location: {
            label: 'Location',
            map: {
              invalid_coordinates: 'Invalid coordinates',
              helper: 'Enter valid latitude and longitude to see location on map',
            },
          },
          seo: {
            label: 'SEO',
            description: 'Define how the article will appear in search results.',
          },
          social: {
            label: 'Social',
            description: 'Define how the article will appear on social media.',
          },
          print_depth: {
            label: 'Print Depth',
            label_alt: 'Print Depth Range',
          },
          print_publication: {
            label: 'Print Publication',
            fields: {
              publication: {
                label: 'Publication',
              },
              edition: {
                label: 'Edition',
              },
              section: {
                label: 'Section',
              },
              zone: {
                label: 'Zone',
              },
              page: {
                label: 'Page',
              },
              location: {
                label: 'Location',
              },
              date: {
                label: 'Date',
              },
              placed: {
                label: 'Placed',
              },
            },
          },
          print_publication_date_range: {
            label: 'Print Publication Date Range',
            help: 'Select publication to set a date range',
          },
          print_publication_status: {
            label: 'Print Publication Status',
            help: 'Select publication to select status',
          },
          print_ready: {
            label: 'Print Ready',
          },
          print_slug: {
            label: 'Slug',
            placeholder: 'Enter a print slug',
            help: 'Find exact slug...',
            description:
              'A Slug serves as a Project ID for your content, containing letters, numbers, underscores, hyphens, spaces, and more. It is used for internal tracking, workflow management, and content organization within Blox CMS.',
          },
          print: {
            label: 'Print Properties',
            ready: {
              label: 'Ready for Print',
              description: '',
            },
            not_ready: {
              label: 'Not Print Ready',
            },
            headline: {
              label: 'Headline',
              description: 'Custom headline for print.',
            },
            subheadline: {
              label: 'Subheadline',
              description: 'Custom subheadline for print.',
            },
            printpriority: {
              label: 'Priority',
              description: "Determines the asset's print order.",
            },
            printImageColor: {
              label: 'Color Image',
              description: 'Image for print in color.',
            },
            printImageBlackWhite: {
              label: 'Black and White Image',
              description: 'Image for print in black and white.',
            },
            jumpkeyword: {
              label: 'Jump Keyword',
              description: 'Keyword used for jump references.',
            },
            jumphead: {
              label: 'Jump Head',
              description: 'Custom headline for continued content.',
            },
            notes: {
              label: 'Notes',
              description: 'Additional information for print.',
            },
          },
        },
      },
      // For article asset type
      article: {
        label: 'Article',
      },
      // For image asset and image general use where applicable
      image: {
        label: 'Image',
        description: 'The file associated with this asset.',
        help: 'Drag and drop or click in the area above to upload a new image file.',
        invalid: 'The URL does not end in .jpeg, .jpg, .png, .gif, .tiff, or .bmp',
        view_full_size: 'View Full Resolution Image',
        dropzone: {
          label: 'Drag and drop an image here, or click to select.',
        },
        photo_sales: {
          label: 'Photo Sales',
          description:
            "Declare whether prints of this photo may be sold. Automatic will examine the asset's data to determine whether the photo is sellable.",
          options: {
            automatic: 'Automatic',
            //Enabled and Disabled use blox.general.enabled and blox.general.disabled for consistency in the UI
          },
          override_tooltip:
            'This asset has a photo sales setting that overrides the site default. Click to reset to the site setting.',
        },
      },
      audio: {
        dropzone: {
          label: 'Drag and drop an audio file here, or click to select.',
        },
      },
      file: {
        success: 'File uploaded successfully.',
        transfering: 'Transferring...',
        dropzone: {
          label: 'Drag and drop a file here, or click to select.',
        },
        error: {
          asset: 'Unable to set from provided asset',
          invalid: 'The URL does not end in an accepted file extension.',
          failed: 'Error getting file from URL.',
        },
      },
      video: {
        dropzone: {
          label: 'Drag and drop a video file here, or click to select.',
        },
        processing:
          'Your video is being converted to a web-ready format and is not yet available for viewing.',
        drop_to_upload: 'Drop to upload new video.',
        blackbird: {
          not_configured: 'Blackbird is not configured for this site.',
        },
      },
      revisions: {
        label: 'Revisions',
        endOfResults: 'No more revisions...',
        noChanges: 'No changes found.',
        notAvailableTooltip: 'Revision history not available.',
        buttons: {
          restore_previous: 'Restore to previous revision',
          restore_selected: 'Restore to selected revision',
          selected_revision: 'Selected revision',
          most_recent_save: 'Most recent save',
          previous_revision: 'Previous revision',
          restore: 'Restore to this revision',
          duplicate_revision: 'Duplicate from revision {{revisionId}}',
          duplicate_revision_simple: 'Duplicate {{assetType}}',
        },
        before: {
          label: 'Before',
        },
        after: {
          label: 'After',
        },
        removed: {
          label: 'Removed',
        },
        fields: {
          versionHistory: {
            label: 'Version History',
            options: {
              all: 'All',
              currentUser: 'Your Revision History',
            },
          },
          search: {
            label: 'Search revisions...',
          },
          viewHistorically: {
            label: 'View Historically',
          },
          revertModal: {
            label: 'Restore to the following revision?',
            confirm: 'Confirm',
            cancel: 'Cancel',
            noComment: 'No comment provided',
          },
        },
        current: {
          label: 'Current',
        },
        previous: {
          label: 'Previous',
        },
        unknownUser: {
          label: 'Unknown User',
        },
        errors: {
          revert: 'Error restoring to revision.',
          noRevisions: 'No revisions found.',
          noRevisionsCurrentUser: 'No revisions found for the current user.',
          header: `There was an error processing your request.`,
          duplicate_error: 'Error duplicating revision.',
        },
        duplicate_success: 'Revision {{revisionId}} duplicated',
        quick_launch: {
          revision_label: 'Revision {{revisionId}}',
          revision_label_fallback: 'Revision',
        },
        asset_fallback: 'Asset',
        viewableTooltip: 'Viewable',
        draftTooltip: 'Draft',
      },
      settings: {
        label: 'Settings',
        help: 'Select a setting from the sidebar to view and edit its configuration.',
        ai: {
          label: 'AI Settings',
          help: 'Editorial AI settings.',
          summary: `Control various AI-driven features to enhance your editorial workflow. Toggle
          assistant suggestions for headlines, summaries, and metadata, or enable advanced
          content editing options like rephrasing and extending text with content
          extensions.`,
          siteLevel: 'These settings are applied only to: ',
          fields: {
            assistantSuggestions: {
              label: 'Enable Assistant Suggestions',
              description:
                'Toggle on or off suggestions for headlines, summaries, and metadata items.',
            },
            contentExtensions: {
              label: 'Enable Content Extensions',
              description:
                'Toggle access to advanced content editing options like rephrasing and extending sentences or paragraphs using the formatting pallette.',
            },
            contentSuggections: {
              label: 'Enable Content Suggestions',
              description:
                'Toggle on or off suggestions for content grammar and spelling enhancements.',
            },
          },
        },
        relatedContentStyles: {
          label: 'Related Content Styles',
          help: 'Settings for the related content styles.',
          addButton: 'Add New',
          updateButton: 'Update',
          cancelButton: 'Cancel',
          error: 'An error occurred.',
          drawer: {
            new: {
              title: 'Add New Related Content Style',
            },
            edit: {
              title: 'Edit Related Content Style',
            },
          },
          columns: {
            name: 'Style Name',
            type: 'Type',
            edit: 'Edit style',
            delete: 'Delete style',
            deleteConfirmation:
              'Are you sure you want to delete this related content style?',
          },
          fields: {
            name: {
              label: 'Name',
              requiredMsg: 'Required.',
            },
            type: {
              label: 'Type',
              requiredMsg: 'Type is required',
              placeholder: 'Select type',
            },
            default_title: {
              label: 'Default Title',
              invalid: 'Invalid',
            },
            force_title: {
              label: 'Force Use of Default Title',
              helpText: 'Force the use of the default title',
            },
          },
          notifications: {
            deleted: 'Related content style deleted.',
            error: 'Error updating related content style.',
            deleteError: 'Error deleting related content style.',
            success: 'Related content style saved.',
          },
        },
      },
      collection: {
        label: 'Collection',
        add_items: 'Use the asset library to add items to the collection.',
        insert_or_drag:
          'Insert or drag items from the asset library to add them to the collection.',
        max_limit: `Collections have a maximum of {{max}} items.`,
        duplicates: `No new items added. (Duplicates skipped: {{count}})`,
        selectionLimited: 'Selection is limited to {{count}} items.',
        selectionLimitedSelectAll: 'Selection limited to the first {{count}} items.',
        added_one: 'Added {{count}} item to the collection.',
        added_other: 'Added {{count}} items to the collection.',
        added_with_duplicates_one:
          'Added {{count}} item to the collection. (Duplicates skipped: {{duplicates}})',
        added_with_duplicates_other:
          'Added {{count}} items to the collection. (Duplicates skipped: {{duplicates}})',
        hide_headlines: {
          label: 'Hide Headlines',
          tooltip: 'Hides the headlines of child assets.',
        },
        hide_details: {
          label: 'Hide Details',
          tooltip: 'Hides the byline, caption, and other details of child assets.',
        },
        upload: {
          label: 'Upload to Collection',
          description: 'Upload files into this collection.',
          close_warning:
            'Uploaded files will not be added to the collection. Remaining uploads will be canceled.',
          rejected_files: 'Unsupported file type(s): {{rejectedNames}}',
          untitled_file: 'Untitled File',
          preview_of: 'Preview of {{name}}',
        },
      },
      dynamic_collection: {
        label: 'Dynamic Collection',
        curated: 'Curated',
        dynamic: 'Dynamic',
        curated_info:
          'Curated collections are managed manually, add and reorder assets via the Asset Library.',
        dynamic_info:
          'Dynamic collections update automatically when new content matches your search rules.',
        change_type_header: 'Change Collection Type?',
        modify_search: 'Modify Search',
        create_search: 'Create Search',
        search_info:
          'Automatically populate this collection with assets that match search criteria.',
      },

      moreActions: {
        button: 'More Actions',
        saveTemplate: 'Save as Template',

        useTemplate: 'Use Template',
        duplicate_disabled: 'Duplicate disabled',
        duplicate_failed: 'Duplicate failed: {{error}}',
        save_template_failed: 'Save as template failed: {{error}}',
        archive_and_delete_date: 'Archive and Delete Date',
        archive_date: 'Archive Date',
        delete_date: 'Delete Date',
      },
      template: {
        label: 'This is a {{type}} Template',
        live_view: {
          tooltip: 'Templates do not offer live view',
        },
      },
      deleted: {
        banner: 'This asset has been deleted.',
      },
      inline: {
        insert_inline: 'Insert inline',
        placeholder: 'Placeholder',
        align: 'Align',
        width: 'Width',
        presentation: 'Presentation',
        displayProperties: {
          alignment: {
            left: 'Left',
            center: 'Center',
            right: 'Right',
            default: 'Default',
          },
          width: {
            default: 'Default',
            'one-third': 'One-Third',
            half: 'Half',
            'two-thirds': 'Two-Thirds',
            full: 'Full',
          },
          presentation: {
            default: 'Default',
            headline: 'Headline link',
            summary: 'Summary',
            short_summary: 'Short summary',
            presentation: 'Asset presentation',
            parallax: 'Parallax',
            fullbleed: 'Full-bleed',
            hide_details: 'Hide Details',
            player: 'Media Player',
            html: 'HTML',
            preview: 'Preview',
            download: 'Download link',
            pdf: 'PDF preview',
            poll: 'Poll',
            mosaic: 'Mosaic',
            table: 'Table',
          },
        },
        article_specific: 'Overridden',
        asset_value: 'Override',
        article_specific_tooltip: 'Using article-specific value',
        asset_value_tooltip: 'Using original asset value',
        reset_to_asset: 'Reset to asset {{field}}',
        override_save_reminder:
          'Article-specific overrides have been modified. Save the article to apply these changes.',
      },
      locked: {
        label: 'Asset Locked',
        reason: {
          env: 'This asset is locked in another environment.',
          user: 'This asset is locked by another user.',
          default: 'This asset is locked.',
        },
        action: {
          force_unlock: {
            label: 'Force unlock in Legacy Admin',
            help: "This asset is currently being edited in the Legacy Admin by {{user}}. Forcing an unlock may cause the other user's work to be lost. Are you sure you want to continue?",
            success: 'Asset unlocked',
            error: 'Error unlocking asset',
          },
        },
        origin: 'Lock origin:',
        by: 'Locked by:',
        help: {
          readonly: 'You are in Read-Only mode',
        },
      },
      toolbar: {
        search_replace: {
          tooltip: 'Find and Replace',
          find: {
            label: 'Find',
            placeholder: 'Find...',
          },
          replace: {
            label: 'Replace',
            placeholder: 'Replace with...',
          },
          match_case: 'Match case',
          match_whole_word: 'Match whole word',
          results: 'Results: {{current}} / {{total}}',
          button: {
            previous: 'Previous',
            next: 'Next',
            replace: 'Replace',
            replace_all: 'Replace All',
          },
        },
        undo: 'Undo | Ctrl+Z',
        undo_change: 'undo change',
        redo: 'Redo | Ctrl+Y',
        redo_change: 'redo change',
        heading_level: 'heading level',
        bold: 'Bold | Ctrl+B',
        italic: 'Italic | Ctrl+I',
        underline: 'Underline | Ctrl+U',
        insert_link: 'Insert link',
        link_to_url: 'Link to URL',
        link_to_asset: 'Link to Asset',
        edit_link: 'Edit link',
        remove_link: 'Remove link',
        insert_comment: 'Insert comment',
        edit_comment: 'Edit comment',
        remove_comment: 'Remove comment',
        bullet_list: 'Bullet list | Ctrl+Shift+8',
        bullet_list_aria: 'bullet list',
        numbered_list: 'Numbered list | Ctrl+Shift+7',
        horizontal_rule: 'Horizontal Rule',
        horizontal_rule_aria: 'horizontal rule',
        page_break: 'Page Break',
        page_break_aria: 'page break',
        inline_note: 'Inline Note',
        omitted_from_published: 'Will be omitted from published content',
        print_trim: 'Print Trim',
        trim_from_print: 'Trim from Print',
        omitted_from_print: 'Will be omitted from print content',
        block_quote: 'Block Quote',
        table: 'Table',
        more: 'More',
        open_more_options: 'Open more options',
        widgetselect: {
          dividers: {
            utilities: 'Utilities',
            headlines: 'Headlines',
          },
          inline_assets: {
            insert_type: 'Insert {{type}}',
            image: 'Image',
            audio: 'Audio',
            video: 'Video',
            link: 'Link',
            html: 'HTML',
            file: 'File',
            open_asset_in_new_window: 'Open asset in new window',
          },
          plaintext: {
            label: 'Paste as Plain Text',
            description: 'Insert clipboard contents as plain text.',
            error: 'Error pasting as plain text.',
            empty: 'Clipboard is empty.',
          },
        },
      },
      syndication: {
        actions: {
          add_to_site: 'Add to Site',
          view_original: 'View Original',
          view_remote: 'View Remote Asset',
          cancel: 'Cancel',
          save: 'Save',
          add_rules: 'Add rules',
          update_rules: 'Update rules',
        },
        channels: {
          label: 'Channels',
          confirm_delete: {
            help: 'Are you sure you want to remove {{channel}} channel from the asset?',
          },
        },
        labels: {
          category_map: 'Category Map',
          category_map_add: 'Add Map',
          category_map_for: 'Category Map for {{name}}',
          channel_category_map_for: 'Channel category map for {{name}}',
          channels: 'Channels',
          channels_info: 'Allows you to access and manage syndication feeds.',
          add_channel: 'Add Channel',
          settings: 'Channel Settings',
          select_driver: 'Select Driver',
          choose_categories: 'Choose one or more channel categories...',
          create_categories: 'Add new categories by typing...',
          categories: 'Categories',
          categories_hint: 'Press Enter or Tab to add',
          choose_sections: 'Choose site sections to map them to...',
          sections: 'Sections',
          rules_info:
            "The rules below will be used to convert channel categories to sections when assets are added to your site. A parent category's rule will be used for any of its children that are not present in their own rules.",
          no_rules: 'Unmapped category or uncategorized asset',
        },
        errors: {
          select_category: 'Please select at least one category',
          select_section: 'Please select at least one section',
        },
        notifications: {
          channel_config_updated: 'Channel configuration updated',
          channel_config_created: 'Channel configuration created',
          category_map_deleted: 'Category map for {{name}} configuration deleted',
          category_map_updated: 'Category map for {{name}} configuration updated',
          failed_to_edit_setting: 'Failed to edit setting: {{error}}',
          error: 'Error: {{error}}',
        },
      },
      save: {
        successful: 'Save successful',
      },
      buttons: {
        save_workflow_actions: 'Save and workflow actions',
      },
      status: {
        published: {
          label: 'Published',
          description: 'Content is live and available',
        },
        draft: {
          label: 'Draft',
          description: 'Work in progress',
        },
        scheduled: {
          label: 'Scheduled',
          description: 'Set to publish at a future date',
          scheduled_date: 'Set to publish {{date}}',
        },
        unpublished: {
          label: 'Unpublished',
          label_alt: 'No Publish',
          description: 'Removed from publication',
        },
        processing: {
          label: 'Processing',
          description: 'Content is being processed',
        },
        deleted: {
          label: 'Deleted',
          description: 'Content has been deleted',
        },
        unpublished_changes: {
          label: 'Unpublished Changes',
          description: 'Published with pending draft edits',
        },
      },
    },
    static: {
      // No assets (block type)
      label: 'Static (no assets)',
    },
    urlmap: {
      label: 'Page Builder',
      input: {
        label: 'URL Map',
        help: 'Select a URL Map',
      },
      actions: {
        add_url: 'Add child page',
        set_skin: `Set page's own skin`,
        inherit_skin: "Inherit parent's skin",
        confirm_delete: {
          label: 'Confirm Deletion',
          help: 'Are you sure you want to delete this page? This action cannot be undone.',
        },
        restore_alias: {
          label: 'Restore Redirect',
          help: "Restore the redirect URL's value",
        },
        search: {
          label: 'Search pages',
        },
        cancel_alias: {
          label: 'Cancel Redirect',
          help: 'Cancel and return to Edit',
        },
        filter: {
          label: 'Filter results',
          alias: 'Redirects Only',
          app: 'Filter by Application',
        },
      },

      customizations: {
        label: 'Page Customizations',
        notifications: {
          saved: 'Page Customizations saved successfully',
          error: 'Error saving Page Customizations',
          reset: 'Page Customizations reset to previous values',
          empty: 'No Page Customizations available',
        },
        confirmations: {
          reload: {
            title: 'Unsaved Changes',
            message:
              'You have unsaved Block Layout changes. Are you sure you want to reload and lose those changes?',
            confirm: 'Reload Anyway',
          },
          navigation: {
            title: 'Unsaved Changes',
            message:
              'You have unsaved Page Customizations. Do you want to continue without saving?',
            confirm: 'Continue',
          },
        },
        validation: {
          invalid_before_saving: 'Please correct invalid values before saving.',
        },
      },
      map: {
        root: {
          label: 'Home',
        },
        name: {
          label: 'Map Name',
        },
        global: {
          label: 'Global Skin',
          help: 'Set the global skin',
        },
        template_library: {
          label: 'Template Library',
        },
      },
      node: {
        label: 'Page Properties',
        name: {
          label: 'Name',
          description: 'The name of the page.',
          help: 'Name is required',
        },
        app: {
          label: 'Application',
        },
        alias: {
          label: 'Redirect URL',
          short_label: 'Redirect',
          help: 'Redirect URL is required',
          warning:
            "Setting a Redirect URL may result in the loss of this page's block placement, and other setttings.",
        },
        title: {
          label: 'Page Title',
          description:
            'A succinct, human-readable phrase to describe this page which search engines use to determine page relevance, boosting your rating.',
        },
        node_label: {
          label: 'Label',
          description:
            "A very short descriptive word or phrase that describes this page that can contribute to search engines' determination of relevance.",
        },
        parent: {
          label: 'Parent Page',
        },
        allow_archiving: {
          label: 'Allow Archiving',
        },
        prevent_indexing: {
          label: 'Prevent Indexing',
        },
        searchable: {
          label: 'Searchable',
        },
        template: {
          label: 'Skin',
          help: 'Set the skin',
        },
      },
      help: {
        select_view: 'Select a page to view.',
        select_edit: 'Select a page to edit.',
        no_results: 'No pages returned',
        redirects_to: 'This page redirects to',
      },
    },
    block_manager: {
      block_library: {
        label: 'Block Library',
      },
      duplicate_block: {
        label: 'Duplicate block',
        success: 'Block duplicated successfully',
        error: 'Failed to duplicate',
      },
      copy_block: {
        error_no_template_library_for_domain: 'No template library found for this domain',
        error_template_library_mismatch: 'Template library mismatch on active URL map',
        error_fetch_all_sites: 'Failed to fetch all sites',
        error_invalid_domain: 'Invalid domain',
        error_no_active_url_map: 'No active URL map found',
        error_fetch_url_map: 'Failed to fetch URL map',
        error_missing_ids: 'Missing map ID or block ID',
        label: 'Copy to site',
        site_select: 'Select sites to copy to',
        target_sites_label: 'Target sites',
        no_target_sites:
          'No other sites available to copy to. You are currently on {{site}}, which is the only site you have access to.',
        processing_progress: 'Processing {{count}} sites... {{progress}}',
        processing_progress_one: 'Processing {{count}} site... {{progress}}',
        retryable_errors_summary: '{{count}} sites failed to process',
        retryable_errors_summary_one: '{{count}} site failed to process',
        summary: 'Successfully copied to {{success}} of {{total}} sites.',
        summary_one: 'Successfully copied to {{total}} site.',
        summary_error: '{{error}} sites were not compatible.',
        summary_error_one: '{{error}} site was not compatible.',
        site_header: 'Site',
        status_header: 'Status',
        confirm_close_title: 'Are you sure you want to close?',
        confirm_close_content: 'Any copies not yet processed will be skipped.',
        confirm_copy_header: 'Confirm Copy Block',
        confirm_copy_sub_text_one: 'Copy this block to {{count}} site',
        confirm_copy_sub_text_other: 'Copy this block to {{count}} sites.',
        confirm_copy_sub_text_all: 'Copy this block to all sites.',
        confirm_copy_button: 'Yes, Copy',
      },
      create_block: {
        label: 'Create a new block',
        app_not_installed: 'Required app not installed',
      },
      edit_block: {
        label: 'Edit {{type}} block #{{id}}',
        loading: 'Loading block data...',
        error: 'Error saving block',
        fail: 'Failed to load block data',
        validation: {
          name_required: 'Block name is required',
        },
      },
      delete_block: {
        label: 'Delete block',
        confirm:
          'Are you sure you want to delete this block? This action cannot be undone.',
        success: 'Block deleted successfully',
        error: 'Failed to delete block',
      },
      unsaved_changes: {
        title: 'Unsaved changes',
        message:
          'You have unsaved block layout changes. Do you want to save these changes before leaving?',
      },
      place_block: {
        label: 'Place block',
        help: 'Please select blocks to place from the Block Library',
        status: 'Placed',
      },
      search_blocks: {
        label: 'Search blocks',
        empty: 'No blocks found',
        filter: {
          label: 'Filter options',
          options: {
            all: 'All',
            app_business: 'app: Business',
            app_calendar: 'app: Calendar',
            app_classifieds: 'app: Classifieds',
            app_editorial: 'app: Editorial',
            app_electionstats: 'app: Election Stats',
            app_eedition: 'app: e-Edition',
            app_static: 'app: Static Blocks',
            placed_yes: 'Placed: Yes',
            placed_no: 'Placed: No',
            sort_name_asc: 'Sort: Name (Ascending)',
            sort_date_created_desc: 'Sort: Date created (Descending)',
            sort_date_modified_desc: 'Sort: Date modified (Descending)',
          },
        },
      },
      query_results: {
        label: 'Query Results',
        empty: 'No results returned',
        actions: {
          pin: {
            label: 'Pin Asset',
            description: 'Do not unpin automatically',
            help: 'The asset will remain pinned until manually unpinned.',
          },
          pin_multiple: {
            label: 'Pin Assets',
          },
          unpin: {
            label: 'Unpin Asset',
          },
          pin_options: 'Pinned asset options',
          schedule_unpin: {
            label: 'Schedule Unpinning',
            description: 'Unpin asset at a specific date and time',
          },
          edit: {
            help: {
              draft_no_publish:
                'Note: Only live assets are returned to blocks. Setting to Draft or "Do not publish" will remove the asset from the block results.',
            },
          },
          override_display: {
            label: 'Override Display',
            toggle: {
              label: 'Override Display Properties',
              description: 'Check to enable overrides',
              description_off: 'Uncheck to use asset values',
            },
            fields: {
              title: {
                label: 'Title',
                description: "Enter an override for this asset's title",
                help: 'Title is required',
              },
              summary: {
                label: 'Summary',
                description: "Enter an override for this asset's summary",
              },
            },
          },
        },
      },
      query_rules: {
        label: 'Query Rules',
        add: 'Add Query Rule',
        help: 'Select the query rule to apply',
        empty: 'No query rules set',
      },
      query_size: {
        label: 'Change query size',
        first_result: 'First result',
        max_results: 'Max results',
        tooltip_first_result: 'Set the starting result',
        tooltip_max_results: 'Set the maximum number of results to display',
        error_first_result: 'Value must be greater than 0',
        error_max_results: 'Value must be between 1 and 50',
      },
      sort_rules: {
        label: 'Sort Rules',
        add: 'Add Sort Rule',
        help: 'Select the sort rule to apply',
        empty: 'No sort rules set',
        random: { label: 'Sort randomly', help: 'Assets will be sorted randomly.' },
        direction: 'Direction',
      },
      customizations: {
        label: 'Customizations',
        search: 'Search customizations',
        loading: 'Loading appearance options...',
        error: 'Error loading appearance options',
      },
      block_title: {
        label: 'Block Title',
        help: 'Enter the block title',
      },
      block_title_link: {
        label: 'Title Link URL',
        help: 'Enter a URL to link the title',
        new_window: 'Open link in new window',
        error: 'Enter a valid URL (https://example.com)',
      },
      links: {
        label: 'Links',
        empty: 'No links entered',
        help: 'Add New Link',
        help_edit: 'Edit Link',
        options: {
          use_url_map: {
            label: 'Select from Page Map',
          },
        },
        fields: {
          link_label: {
            label: 'Label',
            help: 'Enter the label for the link',
          },
          link_url: {
            label: 'URL',
            help: 'Enter the URL for the link',
            error_duplicate: 'This link already exists as entered',
            error_invalid: 'Enter a valid URL (https://example.com)',
          },
        },
      },
      css_classes: {
        label: 'CSS Classes',
        help: 'Accepts multiple classes',
        count: '{{count}} total',
      },
      configuration: {
        label: 'Configuration',
        fields: {
          name: {
            label: 'Block Name',
            description: 'Enter a block name',
            help: 'Block name is required',
          },
          description: {
            label: 'Description',
            description: 'Enter a block description',
          },
          tag: {
            label: 'Add a Tag',
            description: 'Enter tags for the block',
          },
        },
        help: 'Select the configuration to apply',
        empty: 'No configurations set',
      },
      block_preview: { label: 'Block Preview' },
      block_usage: {
        label: 'Block Usage',
        empty: 'This block is not currently used on any pages.',
      },
      template: {
        label: 'Template',
        selected: 'Selected Template',
        loading: 'Loading template options...',
        not_found: 'No {{app}} templates found for "{{search}}"',
      },
      application: {
        label: 'Block type',
        no_edit: 'Block type cannot be changed',
      },
    },
    region_manager: {
      page_rendering_failures: 'Page rendering failures occurred.',
      region: {
        label: 'Page Regions',
        options: 'Options',
        add_blocks: 'Add blocks',
        disinherit_blocks: 'Disinherit Blocks',
        inherit_blocks: 'Inherit Blocks',
        unlock_region: 'Unlock Region',
        lock_region: 'Lock Region',
        thumbnail_alt: 'Region Thumbnail',
        full_size_image_alt: 'Full Size Image',
        search: {
          label: 'Search regions',
          no_results: 'No blocks or regions found',
        },
        filter: {
          label: 'Filter regions',
          description: 'Show regions with blocks from:',
        },
      },
      utility_region: {
        label: 'Utility Regions',
        ungrouped: 'Ungrouped',
        block_count_one: '{{count}} block',
        block_count_other: '{{count}} blocks',
      },
      navigation_region: {
        label: 'Navigation Regions',
        search: {
          label: 'Search navigation',
        },
      },
    },
    state: {
      disabled: 'Disabled',
      enabled: 'Enabled',
    },
    dashboards: {
      label: 'Dashboards',
      titles: {
        default: 'Dashboard',
        editorial: 'Editorial Dashboard',
        subscription: 'User Dashboard',
        emailreach: 'Campaigns Dashboard',
        journeys: 'Journeys Dashboard',
      },
      table: {
        no_data: 'No Data',
        rows_per_page: 'Rows per page:',
        of: 'of',
        more_than: 'more than',
      },
      errors: {
        error: 'An unknown error occurred.',
        noData: 'No data available.',
      },
      exports: {
        title: 'Export as CSV',
        description: 'Exported data will match currently applied filters.',
        description_all: 'All data will be exported.',
        button: 'Export CSV',
        download: 'Begin Export',
        download_started:
          'Your CSV export is being prepared and will begin downloading shortly.',
        export_started: 'CSV export started',
        export_failed: 'CSV export failed',
        preparing: 'Preparing your CSV export...',
        error: 'There was an error preparing your CSV export. Please try again.',
        table_field: {
          label: 'Specify how much data to export:',
          all: 'All Rows',
          25: 'Top 25 Rows',
          50: 'Top 50 Rows',
          100: 'Top 100 Rows',
        },
      },
      needHelp: {
        header: 'Need Help?',
        subtitle: "You've come to the right place.",
        title: 'Getting Started',
        resources: 'Resources',
        bloxUniversity: {
          title: 'BLOX University',
          subtitle: 'Browse our video training courses',
        },
        documentation: {
          title: 'Documentation',
          subtitle: 'Browse our documentation',
        },
        support: {
          title: 'Support',
          subtitle: 'Get help troubleshooting an issue or view your requests',
        },
        updates: {
          title: "What's new in BLOX NXT",
          subtitle: 'See the latest product updates and improvements',
        },
      },
      kpis: {
        trend_sprites: {
          up: 'Up from {{priorValue}}',
          down: 'Down from {{priorValue}}',
          neutral: 'No change from previous period',
        },
        kpi_bar: {
          filters: {
            title: 'Filters',
            description: 'Apply filters to update the data displayed in this ticker.',
          },
        },
      },
      charts: {
        funnel: {
          percent_diff: '{{percent}}% {{direction}} from previous',
        },
      },
      loading_chip: {
        live: 'Live',
        live_on: 'Live updates ON - Refresh every {{refresh}} seconds',
        live_off: 'Live updates OFF - Refresh every {{refresh}} seconds',
        updating: 'Updating',
        error: 'Error',
        refresh: 'Updates Every {{refresh}} minutes',
        min15: 'Updates Every 15 minutes',
        min30: 'Updates Every 30 minutes',
        hour: 'Updates Hourly',
        off: 'OFF',
      },
      mask: {
        title: 'Unlock {{title}} Analytics',
        gen_title: 'Unlock Analytics',
        dashboard: 'Unlock Analytics',
        description:
          'Get access to detailed analytics and insights with our Analytics Add-on.',
        tooltip: 'Available with the Pro DataInsights package.',
      },
      controls: {
        error: 'Sorry, an error occurred while applying filters',
        success: 'Success, updating dashboard data',
        filters_tip:
          'Use filters to customize the data displayed on the dashboard. Filter options may vary by widget.',
        filters_warning: 'Not all widgets support these filters.',
      },
      widgets: {
        applied_filters: 'Applied Filters: {{count}}',
        widget_has_custom_parameters: 'This widget is configured to specific filters.',
        dashboard_filters_may_not_apply: 'Dashboard filters will not apply.',
        filters: 'filters',
        filter: 'filter',
        the: 'The',
        do_not_apply: 'do not apply',
        does_not_apply: 'does not apply',
        to_this_widget: 'to this widget.',
        filters_still_apply: 'filters still apply.',
        filter_still_applies: 'filter still applies.',
        all_other_filters_applied: 'All other filters have been applied.',
        locked_widget: 'Locked widget',
        filter_info: 'Filter information',
      },
      user_permissions: {
        title: 'Missing Permissions',
        description:
          'You don’t currently have access to view this dashboard. Contact your account administrator to request access.',
      },
      custom_dashboards: {
        search: {
          title: 'Title',
          status: 'Status',
          publish: 'Public',
          private: 'Private',
          created_by: 'Created by',
          columns: {
            title: 'Dashboard Name',
            status: 'Status',
            created_by: 'Created By',
          },
          app: {
            label: 'Application',
            placeholder: 'Select an application',
            options: {
              editorial: 'Editorial',
              community: 'Community',
            },
          },
          name: {
            label: 'Dashboard Name',
            placeholder: 'Enter dashboard name',
          },
          type: {
            all: {
              label: 'All',
              desc: 'All dashboards you have access to',
            },
            public: {
              label: 'Public',
              desc: 'Available to all users',
            },
            private: {
              label: 'Private',
              desc: 'Only visible to you',
            },
          },
        },
        edit: {
          title: 'Edit Dashboard: {{dashboardName}}',
          title_disabled: 'Enable editing to change dashboard name',
          success: 'Dashboard updated successfully',
          error: 'Error updating dashboard. Please try again.',
          label: 'Edit Dashboard Title',
          close_btn: 'Exit edit mode and preview dashboard',
          configure_widget: 'Configure Widget - Coming Soon',
          change_layout: 'Change Layout',
          column_empty_msg: 'Drag a widget to this column to add it to your dashboard',
          cancel_title: 'You have unsaved changes',
          cancel_confirmation:
            'You have unsaved changes. Are you sure you want to discard them and exit Edit Mode?',
          save_success: 'Dashboard saved successfully',
          save_error: 'Failed to save dashboard',
          changes_discarded: 'Changes discarded',
          module: {
            modify: 'Configure widget',
            remove_confirm: 'Remove widget?',
            remove_msg:
              'Are you sure you want to remove "{{widgetTitle}}" from the dashboard?',
            remove_tooltip: 'Remove widget from dashboard',
            tooltip: 'Edit dashboard filters, such as date range, hostname, and more.',
            save_error: 'Error saving widget configuration. Please try again.',
            save_success: 'Widget configuration saved successfully',
            display_type: 'Display Type',
            display_type_help: 'Select how you want to display this widget data',
          },
        },
        create: {
          title: 'Create Dashboard',
          success: 'Dashboard created successfully',
          error: 'Error creating dashboard. Please try again.',
          form: {
            title: {
              req: 'Title is required.',
              min: 'Title must be at least 3 characters.',
              label: 'Dashboard Title',
              placeholder: 'Enter dashboard title',
            },
            select_layout: 'Select Layout',
          },
        },
        duplicate: {
          title: 'Duplicate Dashboard',
          success: 'Dashboard duplicated successfully',
          error: 'Error duplicating dashboard. Please try again.',
          form: {
            title: {
              req: 'Title is required.',
              max: 'Maximum 140 characters allowed.',
              min: 'Title must be at least 3 characters.',
              label: 'Dashboard Title',
              placeholder: 'Enter dashboard title',
            },
            duplicate_restrictions: {
              label: 'Duplicate access restrictions',
              caption: 'Copy the users and groups that are able to view this dashboard.',
            },
            copy_suffix: {
              placeholder: 'Copy of {{title}}',
            },
          },
        },
        widget_library: {
          title: 'Widget Library',
          desc: 'Click to add or drag widgets to your dashboard',
          coming_soon:
            'Note: Widget Library integration is in development (CMSADMIN-721)',
          search_placeholder: 'Search widgets...',
          drag_help: 'Drag a widget to this column',
          save_success: 'Widget added successfully',
          save_error: 'Failed to add widget, please try again',
          drag_success: 'Widget moved successfully',
          drag_error: 'Unable to move widget, try again',
          delete_success: 'Widget removed',
          delete_error: 'Unable to remove widget, try again',
        },
        no_access: {
          header: 'Application Not Enabled',
          details:
            'The selected domain does not currently have access to this application.',
          contact: 'Please contact your administrator for more information.',
          not_owner_header: 'Access Denied',
          not_owner_details:
            'You can only edit custom dashboards that you own. This dashboard belongs to a different user.',
        },
        errors: {
          loading: 'Error loading dashboard. Please try again.',
        },
      },
      alerts: {
        label: 'Alerts',
        set_alert: 'Set Alert for {{widgetTitle}}',
        manage_alerts: 'Manage Alerts for {{title}}',
        create_alert: 'Create Alert for {{title}}',
        edit_alert: 'Edit Alert for {{title}}',
        create_new: 'Create New Alert',
        cadence: 'Cadence',
        domains: 'Domains',
        no_more_alerts: 'No more alerts',
        form: {
          when_the: 'When the ',
          of: 'of',
          when_value_of_prefix: 'When the value of ',
          when_value_of_suffix: ' is: ',
          description:
            'Set up alerts to monitor key performance indicators and receive notifications when specific thresholds are met, allowing timely decisions and actions.',
        },
        delete: {
          title: 'Delete alert?',
          warning:
            'Are you sure you want to delete this alert? This action cannot be undone.',
        },
        success: {
          create: 'Alert created successfully',
          update: 'Alert updated successfully',
          delete: 'Alert deleted successfully',
        },
        errors: {
          no_alerts: 'No alerts set',
          no_fields: 'Unable to create alert',
        },
      },
    },
    dynamic_fields: {
      image: {
        dropzone: {
          subtitle: 'Drop image here',
          caption: 'Drag and drop image or click to browse files',
          uploading: 'Uploading...',
        },
      },
    },
    modal: {
      confirmClose: 'Confirm Close',
      confirmClosePrimary: 'Are you sure you want to close?',
      confirmCloseSecondary: 'This action will discard any unsaved changes!',
      cancelCloseBtn: 'Cancel',
      confirmCloseBtn: 'Yes, Close',
      prompt_delete: 'Are you sure you want to delete: {{name}}?',
      prompt_delete_basic: 'Are you sure you want to delete?',
      no_undo: 'This action cannot be undone.',
      confirm_close: {
        header: 'Confirm Close',
        title: 'Are you sure you want to close?',
        description: 'This action will discard any unsaved changes!',
        cancel: 'Cancel',
        confirm: 'Yes, Close',
      },
      confirm_delete: {
        header: 'Confirm Delete',
        title: 'Are you sure you want to delete?',
        description: 'This action is irreversible.',
        pre_confirm: 'Please type in',
        post_confirm: 'below to allow deletion.',
        input_label: 'Confirmation',
        cancel: 'Cancel',
        confirm: 'Yes, Delete',
      },
      simple_confirm: {
        header: 'Confirm',
        title: 'Are you sure?',
        description: '',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      simple_confirm_delete: {
        header: 'Confirm Delete',
        title: 'Are you sure you want to delete?',
        description: 'Any selected items will be deleted.',
        cancel: 'Cancel',
        confirm: 'Yes, Delete',
        purge: {
          header: 'Confirm Permanent Deletion',
          title: 'Are you sure you want to permanently delete?',
          description:
            'This action cannot be undone. The selected item, {{name}}, will be permanently deleted.',
          cancel: 'Cancel',
          confirm: 'Yes, Permanently Delete',
        },
        undo_deletion: {
          header: 'Confirm Undo Deletion',
          title: 'Are you sure you want to undo the deletion of this asset?',
          description: 'The selected item, {{name}}, will be restored.',
          description_multiple: '{{count}} selected assets will be restored',
          cancel: 'Cancel',
          confirm: 'Yes, Undo Deletion',
        },
      },
    },
    nav_builder: {
      header: 'Edit navigation region "{{navRegionKey}}"',
      edit_navigation: 'Edit navigation',
      no_regions_found: 'No navigation regions found.',
      region_type_tab: 'Region type',
      navigation_items_tab: 'Navigation items',
      custom_item: 'Blank item',
      url_map_link: 'URL map link',
      empty_state: 'No navigation items yet. Click Add to create items.',
      edit_navigation_item: 'Edit Navigation Item',
      save_success: 'Navigation saved successfully',
      save_error: 'Error saving navigation',
      autofill_selector: {
        placeholder: 'Select URL from map',
        error: 'Please select a URL from the map',
        manage_exclusions: 'Manage excluded URLs ({{count}})',
      },
      exclusions: {
        header: 'Autofill exclusions',
        empty_state: 'No exclusions added yet.',
      },
      title: {
        label: 'Title',
        error: 'Title is required',
      },
      link: {
        label: 'Link',
        url_map_node: 'Link to URL map node',
        custom_url: 'Link to custom URL',
        none: 'Do not link to anything',
        placeholder_select: 'Select URL from map',
        placeholder_enter: 'Enter URL',
      },
      children: {
        label: 'Children',
        manual: 'Manually create children (using the Add menu)',
        autofill: 'Autofill children from URL map',
      },
      region_types: {
        inherit: {
          label: 'Inherit navigation from parent URL',
          description:
            'This region will use the navigation items defined or inherited by an identically named region on a parent URL.',
        },
        define: {
          label: 'Define new navigation at this URL',
          description:
            'Define new navigation items for this region. Identically named regions on child URLs will inherit from this.',
        },
        autofill: {
          label: 'Autofill navigation from the URL map',
          description:
            'The region will be automatically filled with the descendents of the selected URL.',
        },
        blank: {
          label: 'Do not display any navigation at this URL',
          description:
            'Setting this to blank ensures the region does not appear. Identically named regions on child URLs will inherit this blank state.',
        },
      },
      region_metadata_labels: {
        inherited_from: 'Inherited from {{sourcePath}}',
        autofilled_from: 'Auto filled from {{sourcePath}}',
        blank_display: 'Do not display',
      },
    },
    site_selector: {
      // Site Selector and NoCosmosPermissions
      no_permissions: 'No Permissions',
      message: 'This site or account is not currently participating in BLOX NXT Admin.',
      contact:
        'Please try a different site or contact an administrator for more information.',
      list_error: 'Sorry, an error occured fetching site list data',
      default_error: 'Sorry, an error occured fetching default site data',
      redirected_to_1: 'You were redirected to:',
      redirected_to_2: 'as you did not have access to',
      switch_default_domain: 'Switch to a different site to change your login default',
      enable_login_default: 'Enable to set the current site as your login default',
      on_current_site: 'You are currently on this site',
      active_site: {
        label: 'Active Site',
        placeholder: 'Filter site list...',
      },
    },
    email_reach: {
      actions: {
        new: 'New',
        reconnect: 'Reconnect Email Service Provider',
      },
      common: {
        lists: 'Lists',
        default: 'Default',
        status: {
          label: 'Subscription Status',
          active: 'Subscribed',
          unsubscribed: 'Unsubscribed',
        },
      },

      // Search functionality
      search: {
        title: 'Email Reach Search',
        contact_lists: 'Contact Lists',
        loading: 'Loading contact lists...',
        loading_contacts: 'Loading contacts...',
        loading_messages: 'Loading messages...',
        loading_campaigns: 'Loading campaigns...',
        no_results: 'No contact lists found',
        error: 'Error loading contact lists',
        label: 'Search for specific contact...',
        placeholder: 'Search contact lists...',
        kpi_bar: {
          date_range: 'Change date range',
          start: 'Start',
          end: 'End',
        },
      },

      // Account management
      account: {
        loading: 'Loading accounts...',
        error: 'Error loading accounts',
        empty: 'No accounts found. Please create an ESP account to use this feature.',
        placeholder: 'Select Account',
        aria_label: 'Select EmailReach account',
        creating: 'Creating account…',
        notifications: {
          connected: 'ESP Account connected successfully!',
          create_failed: 'Failed to create account: {{error}}',
        },
        defaults: {
          account_name: 'My ESP Account',
        },
        table: {
          name: 'Name',
          provider: 'Email Provider',
          default: 'Default',
        },
        connect_modal: {
          header: 'Connect Email Service Account',
          section: {
            account_information: 'Account Information',
          },
          fields: {
            account_name: {
              label: 'Account Name',
              placeholder: 'Enter a recognizable name',
              help: 'This name will help you identify this connection in your dashboard',
            },
            email_provider: {
              label: 'Email Provider',
              placeholder: 'Select an email provider',
              help: 'Select the email service you want to connect with',
              no_vendors: 'No vendors available',
            },
          },
          alert_redirect:
            "You'll be redirected to {{vendor}} to authorize this connection.",
          error_loading_vendors: 'Failed to load vendors. Please try again.',
          connect_button: 'Connect Account',
        },
      },

      // Account dropdown
      account_dropdown: {
        label: 'Account',
        tooltip: 'Select Email Reach account',
        switch_account: 'Switch Account',
      },

      // Pre-search content
      pre_search: {
        welcome: 'Welcome to Email Reach',
        select_account: 'Select an account to view contact lists',
        getting_started: 'Getting Started',
      },

      // Contact management
      contact: {
        modal: {
          create_title: 'Create New Contact',
          edit_title: 'Edit Contact',
          loading_contact: 'Loading contact...',
          initializing: 'Initializing...',
        },
        fields: {
          email: {
            from_email: 'Reply-to Address',
            label: 'Email Address',
            required: 'Email is required',
            invalid: 'Enter a valid email',
            email_optional_replies:
              'Optional reply-to email address for recipient replies',
          },
          first_name: {
            label: 'First Name',
            placeholder: 'John',
          },
          last_name: {
            label: 'Last Name',
            placeholder: 'Doe',
          },
          lists: {
            label: 'Contact Lists',
            placeholder: 'Select contact lists...',
            help: 'Add this contact to one or more lists (optional)',
          },
        },
        actions: {
          create: 'Create Contact',
          update: 'Update Contact',
          creating: 'Creating…',
          updating: 'Updating…',
          delete: {
            title: 'Delete Contact',
            warning: 'This action cannot be undone.',
          },
        },
        subscription: {
          toggle_label: 'Email Subscription',
          toggle_helper:
            'Control whether this contact should receive Constant Contact email.',
          button_unsubscribe: 'Unsubscribe Contact',
          button_resubscribe: 'Re-Subscribe Contact',
          status_active:
            'Globally unsubscribe this user from all emails from you as a sender. This action cannot be undone from within Email Reach.',
          status_unsubscribed:
            'This contact is globally unsubscribed. Click below to send a re-subscription confirmation email.',
          description:
            "Unsubscribing stops Constant Contact email but keeps this contact's list memberships intact.",
          resubscribe_tooltip:
            'Constant Contact will email a confirmation link to the contact. They must confirm before newsletters resume.',
          resubscribe_lists_helper:
            'Select at least one contact list before attempting to resubscribe this contact.',
          errors: {
            no_lists:
              'Select at least one list before attempting to resubscribe this contact.',
          },
        },
        resubscribe_modal: {
          header: 'Confirm Re-Subscription',
          title: 'Re-Subscribe Contact',
          description:
            'Re-subscribing will send a confirmation email to this contact. They must click the confirmation link before they can receive emails again.',
          impact_notice:
            'The contact will receive a confirmation email and must explicitly confirm before being re-subscribed. Their subscription status will show as pending until they confirm.',
          consent_checkbox:
            'I confirm that this user has explicitly requested to be re-subscribed and has provided consent to receive emails.',
          confirm_button: 'Send Re-Subscription Email',
        },
        notifications: {
          created: 'Contact created successfully',
          updated: 'Contact updated successfully',
          deleted: 'Contact deleted successfully',
          unsubscribed: 'Contact unsubscribed successfully',
          resubscribed:
            'Re-subscription email sent successfully. The contact must confirm to complete re-subscription.',
        },
        errors: {
          no_account: 'No account id',
          no_account_selected: 'No email account selected.',
          not_found: 'Contact not found',
          load_failed: 'Failed to load contact',
          create_failed: 'Failed to create contact',
          update_failed: 'Failed to update contact',
          delete_failed: 'Failed to delete contact',
          missing_ids: 'Missing ids',
          name_max_length: 'Use {{max}} characters or fewer',
          unknown: 'Unknown error',
          subscription_failed: 'Failed to update subscription status',
        },
        lists: {
          no_lists_available: 'No lists available',
          loading_more: 'Loading more…',
          all_loaded_prefix: 'All lists loaded',
          total: 'total',
          unnamed: 'Unnamed List',
        },
        table: {
          email: 'E-mail',
          first_name: 'First Name',
          last_name: 'Last Name',
        },
      },

      export: {
        button: 'Export',
        preparing: 'Preparing…',
        queued: 'Export requested. Preparing download…',
        success: 'Contacts export downloaded.',
        failed: 'Unable to export contacts.',
        timeout: 'Export is taking longer than expected. Please try again.',
        account_required: 'Select an account to export contacts.',
        list_required: 'Select a list to export contacts.',
        single_list: 'Export one list at a time.',
        default_title: 'Email Reach Contacts Export',
        menu_label: 'Email Reach Contacts',
      },

      // Contact list management
      contact_list: {
        modal: {
          create_title: 'Create New Contact List',
          edit_title: 'Edit Contact List',
          loading_contact_list: 'Loading contact list...',
          initializing: 'Initializing...',
        },
        fields: {
          name: {
            label: 'List Name',
            required: 'List name is required',
            min_length: 'List name must be at least 2 characters',
          },
          from_name: {
            label: 'From Name',
            required: 'From name is required',
            min_length: 'From name must be at least 2 characters',
          },
          priority: {
            label: 'Priority',
            required: 'Priority is required',
            min: 'Priority must be at least 1',
            max: 'Priority cannot exceed 99',
            help: 'Higher priority lists are shown first (1-99)',
          },
          icon: {
            label: 'Icon',
            options: {
              email: 'Email',
              newsletter: 'Newsletter',
              announcement: 'Announcement',
              marketing: 'Marketing',
              notification: 'Notification',
              update: 'Update',
              promotion: 'Promotion',
              event: 'Event',
              news: 'News',
              alert: 'Alert',
            },
          },
          frequency: {
            label: 'Frequency',
            options: {
              daily: 'Daily',
              weekly: 'Weekly',
              bi_weekly: 'Bi-weekly',
              monthly: 'Monthly',
              quarterly: 'Quarterly',
              as_needed: 'As Needed',
              never: 'Never',
            },
          },
          toggles: {
            title: 'List Settings',
          },
          anonymous: {
            label: 'Anonymous List',
            help: 'Allow users to sign up without site registration and login',
          },
          display_on_signup: {
            label: 'Display on Signup',
            help: 'Show this list as an option when site users register',
          },
          hide: {
            label: 'Hide List',
            help: 'Hide this list everywhere except within the admin',
          },
        },
        actions: {
          create: 'Create List',
          update: 'Update List',
          creating: 'Creating…',
          updating: 'Updating…',
          delete: {
            title: 'Delete Contact List',
            warning:
              'This action cannot be undone. All contacts will be removed from this list.',
          },
        },
        notifications: {
          created: 'Contact list created successfully',
          updated: 'Contact list updated successfully',
          deleted: 'Contact list deleted successfully',
        },
        errors: {
          no_account: 'No account ID provided',
          no_account_selected:
            'No email account selected. Please select an account first.',
          not_found: 'Contact list not found',
          load_failed: 'Failed to load contact list',
          create_failed: 'Failed to create contact list',
          update_failed: 'Failed to update contact list',
          delete_failed: 'Failed to delete contact list',
          missing_ids: 'Missing required IDs',
          name_max_length: 'Use {{max}} characters or fewer',
          unknown: 'An unknown error occurred',
          fetch_lists: 'Failed to fetch contact lists',
          invalid_account: 'Invalid account selected',
        },
        table: {
          name: 'List Name',
          contacts: 'Contacts',
          frequency: 'Frequency',
          last_updated: 'Last Updated',
          actions: 'Actions',
        },
        status: {
          active: 'Active',
          inactive: 'Inactive',
          hidden: 'Hidden',
          anonymous: 'Anonymous',
        },
        loading: {
          lists: 'Loading contact lists...',
          more: 'Loading more lists...',
          account: 'Loading account data...',
        },
        empty: {
          title: 'No Contact Lists',
          description: 'Create your first contact list to get started',
          create_button: 'Create Contact List',
        },
      },
      message_modal: {
        header: {
          message_details: 'Message Details',
          loading_message: 'Loading Message...',
          no_subject: '(No subject)',
        },
        status: {
          not_sent: 'Not sent',
          invalid_date: 'Invalid date',
        },
        status_labels: {
          sent: 'Sent',
          completed: 'Completed',
          delivered: 'Delivered',
          active: 'Active',
          queued: 'Queued',
          processing: 'Processing',
          bounced: 'Bounced',
          failed: 'Failed',
          error: 'Error',
          spam: 'Spam',
          blocked: 'Blocked',
        },
        metrics: {
          title: 'Performance Metrics',
          sent: 'Sent',
          opens: 'Opens',
          clicks: 'Clicks',
          forwards: 'Forwards',
          bounces: 'Bounces',
          spam: 'Spam',
        },
        links: {
          title: 'Tracked Links',
          total: 'total',
          url_header: 'URL',
          clicks_header: 'Clicks',
          no_tracked_links: 'No tracked links',
        },
        technical: {
          title: 'Technical Details',
          uuid: 'UUID',
          campaign_id: 'Campaign ID',
          external_id: 'External ID',
          no_value: '—',
        },
        loading: 'Loading...',
        error: {
          failed_to_load: 'Failed to load message',
          missing_account_id: 'Missing account or message id',
          message_not_found: 'Message not found',
        },
      },
      messages: {
        search: {
          label: 'Search for specific message...',
        },
        filter: {
          label: 'Filter by',
          placeholder: 'Select type',
          all_types: 'All Types',
          list: 'List',
          segment: 'Segment',
          list_type_label: 'List Type',
          campaign_type_label: 'Campaign Type',
          select_list_or_segment: 'Select List/Segment',
          scheduled: 'Scheduled',
          single_run: 'Single Run',
          unnamed_list: 'Unnamed List',
          unnamed_segment: 'Unnamed Segment',
          unknown: 'An unknown error occurred',
          fetch_lists: 'Failed to fetch contact lists',
          invalid_account: 'Invalid account selected',
        },
        table: {
          name: 'List Name',
          contacts: 'Contacts',
          frequency: 'Frequency',
          last_updated: 'Last Updated',
          actions: 'Actions',
        },
        status: {
          active: 'Active',
          inactive: 'Inactive',
          hidden: 'Hidden',
          anonymous: 'Anonymous',
        },
        loading: {
          lists: 'Loading contact lists...',
          more: 'Loading more lists...',
          account: 'Loading account data...',
        },
        empty: {
          title: 'No Contact Lists',
          description: 'Create your first contact list to get started',
          create_button: 'Create Contact List',
        },
        pagination: {
          showing: 'Showing {{start}} - {{end}} of {{total}} lists',
          load_more: 'Load More',
          next_page: 'Next Page',
          previous_page: 'Previous Page',
        },
      },
      campaign: {
        pre_search: {
          filter_label: 'Audience',
          all_campaigns: 'All Campaigns',
          active_filter: 'Active filter',
          loading_more: 'Loading more...',
          scroll_for_more: 'Scroll for more',
        },
        modal: {
          create_title: 'Create Campaign',
          edit_title: 'Edit Campaign',
        },
        table: {
          active: 'Active',
          schedule: 'Schedule',
          title: 'Title',
          subject: 'Email Subject',
        },
        mini_menu: {
          duplicate: 'Duplicate',
          edit: 'Edit',
        },
        logs: {
          action: 'View Logs',
          title: 'Campaign Logs',
          log_date: 'Log date',
          loading_more: 'Loading more...',
          no_results: 'No logs found for this campaign.',
          unavailable: 'Logs are unavailable or have expired for this campaign.',
          column: {
            time: 'Time',
            status: 'Status',
            driver: 'Driver',
            message: 'Message',
          },
          target_status: {
            success: 'Success',
            failed: 'Error',
            warning: 'Warning',
            info: 'Info',
            unknown: 'Unknown',
          },
          error: {
            failed_to_load: 'Failed to load campaign logs.',
            missing_params: 'Missing campaign information.',
          },
        },
        steps: {
          type: {
            label: 'Campaign Type',
            title: 'Select Campaign Type',
            required: 'Please select a campaign type',
          },
          details: {
            label: 'Details',
            title: 'Campaign Details',
          },
          schedule: {
            label: 'Schedule',
            title: 'Schedule Configuration',
          },
          recurrence: {
            label: 'Recurrence',
            title: 'Recurrence Configuration',
          },
          review: {
            label: 'Review',
            title: 'Review Campaign',
          },
        },
        types: {
          single: {
            title: 'Single Run Campaign',
            description:
              'A Single Run Campaign delivers a one-time, targeted message to drive immediate engagement.',
          },
          scheduled: {
            title: 'Scheduled Campaign',
            description:
              'A Scheduled Campaign automates a series of emails for consistent long-term audience engagement.',
          },
          single_run: 'single-run campaign',
          campaign: 'campaign',
        },
        fields: {
          type: {
            label: 'Campaign Type',
          },
          audience: {
            label: 'Select Audience',
            help: 'Choose whether to send to a specific contact list or a dynamic segment',
            required: 'Please select an audience',
            type_required: 'Please select an audience type',
            select: 'Select {{type}}',
            all_loaded: 'All {{type}} loaded',
          },
          title: {
            label: 'Campaign Title',
            required: 'Campaign title is required',
          },
          url: {
            label: 'Campaign URL',
            help: 'The landing page URL where recipients will be directed',
            required: 'URL is required',
            invalid: 'Please enter a valid URL starting with http:// or https://',
            placeholder: 'https://www.example.com/landing-page',
          },
          custom_subject: {
            label: 'Use Custom Subject',
            help: 'Override the default subject line with a custom one',
          },
          subject: {
            label: 'Email Subject Line',
            required: 'Custom subject is required',
          },
          disable: {
            label: 'Disable Campaign',
            help: 'Create the campaign in a disabled state. You can enable it later.',
          },
          schedule_type: {
            label: 'Schedule Type',
            help: 'Choose how often the campaign should run',
            required: 'Please select a schedule type',
          },
          start_date: {
            label: 'Start Date',
            required: 'Start date is required',
            future: 'Start date cannot be in the past',
          },
          send_time: {
            label: 'Send Time',
            required: 'Send time is required',
          },
          run_indefinitely: {
            label: 'Run Indefinitely',
            help: 'Campaign will continue running until manually stopped',
          },
          end_date: {
            label: 'End Date',
            required: 'End date is required',
            after_start: 'End date must be after start date',
          },
          interval: {
            label: 'Recurrence Interval',
            required: 'Interval is required',
            recur_every: 'Recur every',
            week: 'week',
            weeks: 'weeks',
            min: 'Interval must be at least 1 week',
            max: 'Interval cannot be greater than 52 weeks',
          },
          days_of_week: {
            label: 'Days of Week',
            help: 'Select which days the campaign should send',
            required: 'Please select at least one day',
          },
          monthly_type: {
            label: 'Monthly Recurrence Type',
            required: 'Please select a recurrence type',
            specific_date: 'Specific Date Each Month',
            specific_weekday: 'Specific Weekday Each Month',
          },
          day_of_month: {
            label: 'Day of Month',
            required: 'Day of month is required',
            range: 'Day must be between 1 and 31',
          },
          occurrence: {
            label: 'Occurrence',
            required: 'Occurrence is required',
            select: 'Select occurrence',
          },
          weekday: {
            label: 'Day of Week',
            required: 'Day of week is required',
            select: 'Select day',
          },
          timezone_notice: 'All times are in your site timezone ({{timezone}}).',
          timezone_utc: 'The selected send time is {{utcTime}} UTC.',
        },
        recurrence: {
          description: 'Choose how often the campaign repeats and which days it sends.',
          frequency_label: 'Frequency',
          frequency_options: {
            weekly: 'Every week',
            biweekly: 'Every other week',
            every_four_weeks: 'Every four weeks',
          },
          custom_label: 'Custom',
          custom_every_prefix: 'Every',
          week_singular: 'week',
          week_plural: 'weeks',
          days_heading: 'Send on these days',
          days_presets: {
            weekdays: 'Weekdays',
            weekends: 'Weekends',
            mwf: 'Mon, Wed, Fri',
            tth: 'Tue & Thu',
          },
          monthly_heading: 'Monthly schedule',
          monthly: {
            options: {
              specific_date: {
                title: 'Specific date',
                description: 'For example, the 15th of every month',
              },
              specific_weekday: {
                title: 'Specific weekday',
                description: 'For example, the first Monday of the month',
              },
            },
            select_day: 'Select the day',
            day_option: 'Day {{day}}',
            last_day: 'Last day',
            custom_input_label: 'Day of month:',
            configure_weekday: 'Configure the weekday',
            weekday_occurrence_prompt: 'Which occurrence?',
            weekday_day_prompt: 'Which day?',
          },
        },
        sections: {
          information: 'Campaign Information',
          time_duration: 'Schedule Time and Duration',
        },
        audience: {
          contact_list: 'Contact List',
          segment: 'Segment',
          lists: 'lists',
          segments: 'segments',
        },
        schedule: {
          weekly: 'Weekly',
          monthly: 'Monthly',
        },
        schedule_preview: {
          upcoming: 'Upcoming sends',
          summary_label: 'Schedule:',
        },
        schedule_details: {
          single: {
            summary: 'Scheduled as a one-time send.',
            detail: 'This campaign will send once on the scheduled date.',
          },
          incomplete: {
            summary: 'Complete the schedule to see a summary.',
          },
          weekly: {
            summary_every_week: 'Repeats every week.',
            summary_every_interval: 'Repeats every {{interval}} weeks.',
            days_label: 'Send on',
          },
          monthly: {
            summary_specific_date: 'Repeats on day {{day}} of each month.',
            day_label: 'Day of month',
            warning_short_months: 'Months with fewer than {{day}} days will be skipped.',
            summary_specific_weekday:
              'Repeats on the {{occurrence}} {{day}} of each month.',
            weekday_label: 'Monthly send',
          },
          time_label: 'Send time',
          not_set: 'Not set',
          start_label: 'Start date',
          end_label: 'End date',
          duration_label: 'Duration',
          run_indefinitely: 'Runs indefinitely',
        },
        occurrence: {
          first: 'First',
          second: 'Second',
          third: 'Third',
          fourth: 'Fourth',
          last: 'Last',
        },
        occurrence_short: {
          first: '1st',
          second: '2nd',
          third: '3rd',
          fourth: '4th',
          last: 'Last',
        },
        review: {
          campaign_type: 'Campaign Type',
          audience: 'Audience',
          details: 'Campaign Details',
          schedule: 'Schedule',
          disabled_state: 'Campaign will be created in disabled state',
          ready_message: {
            create_scheduled:
              'Your campaign is ready to be created! Click "Create Campaign" to proceed.',
            create_single:
              'Your single run campaign is ready to send! Click "Create Single Run" to proceed.',
            edit: 'Review your changes and click "Update Campaign" to save.',
          },
        },
        actions: {
          creating: 'Creating...',
          create_single_run: 'Create Single Run',
          create_campaign: 'Create Campaign',
          update_campaign: 'Update Campaign',
          updating: 'Updating...',
          back_to_review: 'Back to Review',
        },
        notifications: {
          created: '{{type}} created successfully!',
          updated: 'Campaign updated successfully!',
          load_failed: 'Failed to load campaign',
          update_failed: 'Failed to update {{type}}',
          duplicate_expired_dates:
            'The original campaign dates have expired. Please update the start and end dates.',
        },
        errors: {
          no_account: 'No account selected',
          create_failed: 'Failed to create {{type}}',
          update_failed: 'Failed to update {{type}}',
          load_failed: 'Failed to load campaign',
          not_found: 'Campaign not found',
        },
        type: {
          label: 'Type',
        },
        not_set: 'Not set',
        loading: 'Loading campaign...',
        loading_description: 'Preparing your campaign details...',
      },

      // Reauthentication
      reauth: {
        success_notification: 'Reconnected to {{vendor}} successfully!',
        error_start_login: 'Failed to start login. Please try again.',
        success_message: 'Account reconnected successfully!',
        error_message: 'There was a problem reconnecting your account. Please try again.',
        prompt_message:
          'Your {{vendor}} session has expired. Please log in again to continue.',
        success_title: 'Connection Restored',
        success_description: 'Your {{vendor}} account has been successfully reconnected.',
        redirect_message: 'Redirecting to {{vendor}}...',
        warning_verify_account:
          'Please verify you are logging into the correct {{vendor}} account.',
        loading_provider: 'Loading provider information...',
        done_button: 'Done',
      },

      // User view widget
      user_widget: {
        title: 'Newsletter Lists',
        add_button: 'Add',
        save_button: 'Save',
        saving_button: 'Saving...',
        cancel_button: 'Cancel',
        unsubscribe_all_button: 'Opt user out globally',
        unsubscribing_button: 'Opting out...',
        remove_button: 'Remove',
        email_newsletter_list_header: 'Email Newsletter List',
        newsletter_subscriptions_header: 'Newsletter Subscriptions',
        account_label: 'Account',
        email_reach_lists_label: 'Email Reach lists',
        select_lists_help:
          'Select newsletter lists for {{email}}. Scroll to load more lists.',
        all_lists_loaded: 'All available lists are loaded.',
        newsletter_actions_aria: 'Newsletter actions for {{listName}}',
        remove_from_list: 'Remove from {{listName}}',
        list_fallback: 'list',
        untitled_list: 'Untitled list',
        empty: {
          requires_permission: 'Requires {{permission}}.',
          no_account: 'No Email Reach account is configured.',
          setup_cta: 'Set up Email Reach',
          no_email: 'This user does not have an email address.',
          globally_unsubscribed: 'This contact is globally unsubscribed.',
          no_lists_available: 'No Email Reach newsletter lists are available.',
          unsubscribed_from_all:
            'This contact is unsubscribed from all Email Reach newsletters.',
          no_subscriptions: 'No newsletter subscriptions available.',
        },
        unsubscribe_all_modal: {
          title: 'Opt user out globally?',
          description:
            'This will globally unsubscribe {{email}} from Email Reach emails for this sender.',
          warning:
            'This user will have a status of unsubscribe and will no longer be able to receive emails from this sender. This cannot be undone from the Contacts portion of NXT, and users will have to confirm via email to opt back into a subscribed status.',
          acknowledgement: 'I understand this contact cannot be re-subscribed here.',
        },
        notifications: {
          subscriptions_updated: 'Newsletter subscriptions updated.',
          subscriptions_update_failed: 'Failed to update newsletter subscriptions.',
          create_contact_failed: 'Failed to create Email Reach contact.',
          unsubscribed_all: 'Contact unsubscribed from all Email Reach newsletters.',
          unsubscribe_failed: 'Failed to unsubscribe contact.',
          cannot_resubscribe:
            'This contact is globally unsubscribed and cannot be resubscribed here.',
        },
      },
    },
    common: {
      days: {
        short: {
          sun: 'Sun',
          mon: 'Mon',
          tue: 'Tue',
          wed: 'Wed',
          thu: 'Thu',
          fri: 'Fri',
          sat: 'Sat',
        },
        full: {
          sunday: 'Sunday',
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
        },
        table: {
          title: 'Title',
          status: 'Status',
          sent_date: 'Sent Date',
        },
      },
      address_suggestions: {
        searching: 'Searching addresses...',
        empty_prompt: 'Type to start searching for addresses',
      },
    },
    general: {
      anywhere: 'Anywhere',
      asset_types: {
        '*': 'All',
        article: 'Article',
        image: 'Image',
        collection: 'Collection',
        audio: 'Audio',
        file: 'File',
        flash: 'Flash',
        html: 'HTML',
        link: 'Link',
        pdf: 'PDF',
        poll: 'Poll',
        table: 'Table',
        video: 'Video',
        youtube: 'YouTube',
        zip: 'ZIP',
      },
      aspect_ratio: 'Aspect ratio',
      please_be_aware: 'Please be aware of the following.',
      no_access: 'Sorry, you do not have access to this feature.',
      no_options: 'No options available.',
      contact_us: 'Contact Us',
      contact_blox: 'Contact us for more information.',
      any: 'Any',
      auto: 'Auto',
      appearance: 'Appearance',
      asset: 'Asset',
      assets: 'Assets',
      block: 'Block',
      blocks: 'Blocks',
      blox: 'BLOX',
      beta: 'Beta',
      beta_feature: 'This feature is currently in beta.',
      canceled_by_user: 'Canceled by user',
      canceled: 'Canceled',
      characters: 'characters',
      close_without_applying: 'Close without applying',
      coming_soon: 'Coming Soon',
      comments: 'Comments',
      created: 'created',
      configuration: 'Configuration',
      contact_sales: 'Contact Sales',
      contributed: 'Contributed',
      default: 'Default',
      disabled: 'Disabled',
      count_selected: '{{count}} selected',
      show_count_results: 'Showing {{count}} results',
      count_total: '{{count}} total',
      count_results: '{{count}} results',
      count_results_one: '{{count}} result',
      count_results_other: '{{count}} results',
      collaborators: 'Collaborators',
      current: 'Current',
      disconnected: 'Disconnected',
      no_results: 'No results',
      search_text_disabled_placeholder: 'Text search disabled...',
      flags: 'Flags',
      date: {
        label: 'Date',
        start_date: 'Start date',
        end_date: 'End date',
        range: {
          custom: 'Custom Date Range',
          week: 'Last 7 Days',
          month: 'Last 30 Days',
          year: 'Last Year',
          select: 'Select a date range',
        },
      },
      date_range: {
        select: 'Select Date Range',
        invalid_input: 'Invalid input.',
        range_invalid: 'Range invalid - end date is before start date.',
        start_prefix: 'Start: {{date}}',
        end_prefix: 'End: {{date}}',
        clear_input: 'Clear Input',
        help_text:
          'This field supports relative and absolute date formats, such as these examples below.',
        presets: {
          today: 'Today',
          yesterday: 'Yesterday',
          tomorrow: 'Tomorrow',
          last_30_days: 'Last 30 Days',
          next_30_days: 'Next 30 Days',
        },
        examples: {
          standard_textual: 'Standard textual dates',
          american_mdy: 'American month/day/year',
          month_and_year: 'Month and year',
          start_of_today: 'Start of today',
          start_of_next_monday: 'Start of next monday',
          days_ago: '7 days ago from now',
          weeks_from_now: '2 weeks from now',
        },
      },
      deleted: 'Deleted',
      template: 'Template',
      description: 'Description',
      end_of_results: 'End of results',
      entry: 'Entry',
      enter_type: 'Enter {{type}}',
      enter_a_type: 'Enter a {{type}}',
      no_entries: 'No entries',
      no_fields_configured: 'No fields configured',
      items: 'Items',
      design: 'Design',
      display: 'Display',
      enabled: 'Enabled',
      error: 'Error',
      filter: 'Filter',
      filters: 'Filters',
      import_mode: 'Import Mode',
      import: 'Import',
      invalid_url_help: 'Invalid URL or must start with http:// or https://',
      export: 'Export',
      export_mode: 'Export Mode',
      include_children: 'Include children',
      edit_not_supported: 'Editing {{type}} is not supported',
      importing: 'Importing',
      label: 'Label',
      loading: 'Loading...',
      initializing: 'Initializing...',
      login: 'Login',
      more: 'More',
      name: 'Name',
      new: 'New',
      no: 'No',
      no_selections: 'No selections',
      none: 'None',
      preview: 'Preview',
      primary: 'Primary',
      group: 'Group',
      live: 'Live',
      live_view: 'Live view',
      no_preview: 'No preview available',
      no_more_results: 'No more results',
      no_results_found: 'No results found',
      off: 'Off',
      on: 'On',
      options: 'Options',
      origin: 'Origin',
      original: 'Original',
      permission_required: 'Permission required',
      placed_on_page: 'Placed on Page',
      provide_url: 'Provide a URL',
      publications: 'Publications',
      processing: 'Processing',
      privacy: 'Privacy',
      private: 'Private',
      queued: 'Queued',
      range: 'Range',
      readonly: 'Read-Only',
      relationships: 'Relationships',
      required: 'Required',
      retry: 'Retry',
      results_of_total_one: 'Showing {{results}} of {{count}} result',
      results_of_total_other: 'Showing {{results}} of {{count}} results',
      save_success: 'Save successful',
      search: 'Search',
      searchEllipsis: 'Search...',
      search_groups: 'Search groups...',
      search_url: 'Search or paste a URL',
      search_results: 'Search Results',
      select_date: 'Select Date',
      selected_assets: 'Selected assets',
      selected: 'selected',
      send_to_top: 'Send to Top',
      set_as_origin: 'Set as Origin',
      search_or_add: 'Search or add',
      showing_total_results: 'Showing {{total}} total results',
      no_results_press_enter_to_add: 'No results found. Press enter to add.',
      menu_of: 'Menu - {{label}}',
      remove_item: 'Remove {{label}}',
      remove_origin: 'Remove origin',
      settings: 'Settings',
      sessions: 'Sessions',
      showing: 'Showing',
      status: 'Status',
      status_primary: 'Primary Status',
      suggestion: 'Suggestion',
      ignore: 'Ignore',
      shareable: 'Shareable',
      shared: 'Shared',
      success: 'Success',
      title: 'Title',
      target: 'Target',
      type: 'Type',
      test: 'Test',
      hidden: 'Hidden',
      updated: 'updated',
      untitled: 'Untitled',
      use_url: 'Use URL',
      update_required: 'Update Required',
      update_app_help: 'A new version of BLOX NXT is ready. Click to update all tabs.',
      update_app_suggest:
        'A new version of BLOX NXT is ready. Proceed to update all tabs, but be sure to save any changes in open tabs first.',
      valid_hex: 'Enter valid hex (e.g. #FF0000)',
      words: 'words',
      yes: 'Yes',
      message: {
        label: 'Message',
        unexpectedError: 'An unexpected error occurred.',
        no_preview: 'No preview available',
        oops: 'Oops! Something went wrong',
      },
      noAccess: 'Sorry, you do not have access to this feature.',
      noAccessSimple: 'Access required',
      contactBlox: 'Contact us for more information.',
      screenshot: 'Create a screenshot',
      capture_screenshot: 'Capture a screenshot',
      play_video_to_capture: 'Play the video to capture a screenshot',
      screenshot_not_supported: 'Screenshot capture not supported for this video',
      value_added_content: 'Value-Added Content',
      view_at_site: 'View at site',
      will_delete_one: '{{count}} item will be deleted.',
      will_delete: '{{count}} items will be deleted.',
    },
    error: {
      label: 'Error',
      invalid_form: 'The form is invalid. Please check for errors.',
      unexpectedError: 'An unexpected error occurred.',
      bad_request: 'Bad request',
      oops: 'Oops! Something went wrong',
      unknown: 'Unknown error',
      sorry_try_again: 'Sorry, an unexpected error occurred. Please try again.',
      required: 'Required.',
      min: '{{field}} must be at least {{min}}',
      max: '{{field}} must be at most {{max}}',
      type_not_accepted: 'This file type is not accepted.',
      only_one_file: 'Only one file can be provided at a time.',
    },
    validation: {
      form_invalid: 'The form is invalid',
      form_invalid_long: 'The form is invalid, please check for errors.',
      value_invalid_generic: 'The input is invalid.',
      value_must_be_array: '{{label}} must be an array',
      value_required: '{{label}} is required',
      value_count_required: '{{label}} must have at least {{count}} selected',
      value_invalid: '{{label}} is invalid',
      value_incomplete: '{{label}} is incomplete',
      value_empty: '{{label}} cannot be empty',
      value_too_long: '{{label}} is too long',
      date_invalid: '{{label}} is not a valid date',
      date_invalid_past: '{{label}} cannot be in the past',
      date_invalid_future: '{{label}} cannot be in the future',
      field_required: 'This field is required',
      incomplete_form: 'Please fill out all required fields',
      email_invalid: 'The email address is invalid',
    },
    notifier: {
      label: 'Notifier',
      channel_disabled: 'channel disabled',
      channels: 'Channels',
      create_post: 'Create Post',
      notifier_post: 'Notifier Post',
      editing_post: 'Editing Post',
      viewing_post: 'Viewing Post',
      disabled_create: 'Notifier is disabled in create mode',
      disabled_import: 'Notifier is disabled in import mode',
      disabled_mode: 'Notifier is disabled in this mode',
      draft_asset_disabled: 'Assets in draft status are unable to be scheduled.',
      message_published: 'Message published',
      no_posts_found: 'No posts found',
      no_channels_found: 'No channels found',
      save_draft: 'Save Draft',
      schedule_post: 'Schedule Post',
      scheduled_date_and_time: 'Scheduled date and time',
      status_uneditable: '{{status}} posts cannot be edited',
      status_undeletable: '{{status}} posts cannot be deleted',
      target_info: 'Select an asset or provide a url.',
      validation: {
        valid_target_required: 'An asset or valid URL is required',
        publish_channels_required: 'At least one channel is required to schedule',
        date_invalid_start_time: 'Date must be after or equal to assets start date',
        date_in_past_warning:
          'With date set in the past, the post will be made as soon as possible.',
        channel_name_required: 'Channel name is required',
        at_least_one_target: 'At least one delivery target is required',
        at_least_one_rule: 'At least one rule is required to save',
      },
      status: {
        draft: 'draft',
        canceled: 'canceled',
        failed: 'failed',
        pending: 'pending',
        sent: 'sent',
        staged: 'staged',
        undelivered: 'undelivered',
        partially_sent: 'partially sent',
        partially_sent_info: 'Delivered to some platforms, failed on others',
        unknown: 'unknown',
      },
      logs: {
        action: 'View Logs',
        title: 'Delivery Logs',
        log_date: 'Log date',
        send_status: 'Send status',
        loading_more: 'Loading more...',
        no_results: 'No delivery logs found for this send.',
        column: {
          time: 'Time',
          status: 'Status',
          driver: 'Driver',
          message: 'Message',
        },
        target_status: {
          success: 'Success',
          failed: 'Failed',
          warning: 'Warning',
          info: 'Info',
          unknown: 'Unknown',
        },
        error: {
          failed_to_load: 'Failed to load delivery logs.',
          missing_params: 'Missing send information.',
        },
      },
      search: {
        search_messages: 'Search messages...',
        asset_app: 'Application',
        domain: 'Domain',
        target: 'Target',
        message: 'Message',
        title: 'Title',
        social_title: 'Social title',
        social_summary: 'Social summary',
        send_date: 'Send date',
        send_status: 'Status',
        type: 'Type',
        channels: 'Channels',
      },
      channel: {
        title: 'Channel',
        create_channel: 'Create Channel',
        edit_channel: 'Edit Channel',
        delete_channel: 'Delete Channel',
        channel_name: 'Channel Name',
        general: 'General',
        automatic_notification_rules: 'Automatic notification rules',
        delivery_targets: 'Delivery Targets',
        select_delivery_targets: 'Select Delivery Targets',
        add_targets: 'Add Targets',
        manage_targets: 'Manage Targets',
        no_targets_selected: 'No delivery targets selected',
        enabled: 'Enabled',
        disabled: 'Disabled',
        all_systems_operational: 'All systems operational',
        auto_notification: 'Automatic notification',
        last_active: 'Last active',
        automatic_notify: 'Automatic notify',
        last_used_days_ago: 'Last used {{days}} days ago',
        last_used_months_ago: 'Last used {{months}} months ago',
        never_used: 'Never used',
        search_channels: 'Search channels...',
        no_channels: 'No channels found',
        filter_message_id: 'Message',
        targets: {
          mobile_app: 'Mobile App',
          facebook: 'Facebook',
          webhook: 'Webhook',
          push_notification: 'Push Notification',
        },
        rules: {
          title: 'Auto Notification Rules',
          create_rule: 'Create Rule',
          edit_rule: 'Edit Rule',
          delete_rule: 'Delete Rule',
          rule_type: 'Rule Type',
          asset_type: 'Asset Type',
          asset_types_label: 'Asset Types',
          flags: 'Flags',
          keyword_tags: 'Keyword Tags',
          section_tags: 'Section Tags',
          select_criteria: 'Select Criteria',
          step_choose_type: 'Choose Rule Type',
          step_select_criteria: 'Select Criteria',
          step_save: 'Save Rule',
          no_rules: 'No automatic notification rules configured',
          inclusion_rule: 'Inclusion Rule',
          rule_name: 'Rule Name (Optional)',
          rule_name_helper: 'Give your rule a descriptive name for easier management',
          selected_values: 'Selected Values',
          enter_keyword: 'Enter keyword',
          no_flags: 'No flags available',
          no_sections: 'No sections available',
          review_rule: 'Review Your Rule',
          select_type_desc:
            'Select a rule type to determine how notifications are triggered',
          suggestions: 'Suggestions',
        },
        confirm_delete: 'Are you sure you want to delete this channel?',
        channel_created: 'Channel created successfully',
        channel_updated: 'Channel updated successfully',
        channel_deleted: 'Channel deleted successfully',
      },
      channel_grid: {
        name: 'Name',
        delivery_targets: 'Delivery Targets',
        auto_notification_rules: 'Auto Notification Rules',
      },
      settings: {
        title: 'Notifier Settings',
        social_accounts: {
          title: 'Social Accounts',
          description: 'Manage social media accounts for Notifier.',
          disconnect: 'Disconnect',
          disconnect_confirm: 'Are you sure you want to disconnect this account?',
          no_accounts: 'No social accounts found.',
          platform: 'Platform',
          account_name: 'Account Name',
          actions: 'Actions',
          account_disconnected: 'Social account disconnected successfully.',
          error_disconnect: 'Failed to disconnect social account.',
          error_loading: 'Failed to load social accounts.',
          account_count: '{{count}} connected',
          account_count_plural: '{{count}} connected',
          unknown_provider: 'Unknown',
        },
        automatic_notifications: {
          title: 'Automatic Notification Settings',
          description:
            'Enable or disable automatic notifications for Notifier channels with a time offset.',
          enable_label: 'Enable Automatic Notifications',
          enable_description:
            'When enabled, notifications are automatically sent for qualifying assets.',
          disable_description: 'When disabled, notifications must be manually triggered.',
          time_offset: 'Time Offset',
          time_offset_help: 'Defines how far back to look for eligible assets.',
          time_offset_unit: {
            minutes: 'Minutes',
            hours: 'Hours',
          },
          time_offset_preview:
            'Notifications will look back {{value}} {{unit}} for eligible assets.',
          save_success: 'Automatic notification settings saved successfully.',
          save_error: 'Failed to save automatic notification settings.',
        },
      },
    },

    journeys: {
      // Journey (Access Criteria)
      journey: 'Journey',
      update_journey: 'Update Journey',
      create_journey: 'Create Journey',
      delete_journey: 'Delete Journey Permanently',
      // Offer Group
      offer_group: 'Offer Group',
      create_offer_group: 'Create Offer Group',
      update_offer_group: 'Update Offer Group',
      edit_offer_group: 'Edit Offer Group',
      delete_offer_group: 'Delete Offer Group Permanently',
      offer_group_name_info: 'A short name to identify this offer group',
      // Method Group
      method_group: 'Method Group',
      method_group_id: 'Method Group ID',
      new_method_group: 'New Method Group',
      create_method_group: 'Create Method Group',
      update_method_group: 'Update Method Group',
      edit_method_group: 'Edit Method Group',
      delete_method_group: 'Delete Method Group Permanently',
      method_group_name_info: 'A short name to identify this method group',
      // Connections Sidepanel - Method Target
      connections: 'Connections',
      method_create_first: 'Information will be shown after creating the method group.',
      method_group_used: 'This method group is connected to journeys.',
      method_group_not_used: 'This method group is not connected to any journeys.',
      // Connections Sidepanel - Rate Target
      rate_used: 'This rate is connected to journeys.',
      rate_not_used: 'This rate is not connected to any journeys.',
      rate_create_first: 'Information will be shown after rate creation.',

      // Method Group Labels
      method: 'Method',
      methods: 'Methods',
      wall_behavior: 'Wall behavior',
      display_content: 'Display content',
      hard_paywall_block: 'Hard paywall block',
      hard_paywall_block_info:
        'User must subscribe or perform the action to see the content',
      nag_mode: 'Nag mode',
      nag_mode_info: 'User can dismiss by clicking the X, then able to see the content',
      select_methods: 'Select methods',
      customjavascript: 'Custom JavaScript',
      mailinglist: 'E-mail Newsletter Signup',
      subscription: 'Subscription',
      user_registration: 'User Registration',
      free_access: 'Free access',
      meter: 'Meter',
      // Access Criteria Labels
      criteria_name_desc: 'Name this criteria',
      appman_title: 'App profile',
      archivetime_title: 'Archive Time',
      asseteditortoggle_title: 'Asset Editor Toggle',
      assetflag_title: 'Flag',
      assettype_title: 'Asset Type',
      customjs_title: 'Custom JavaScript',
      dmp_title: 'DMP Audience',
      gdpr_title: 'GDPR Country',
      hostname_title: 'Hostname',
      incognito_title: 'Private/Incognito Browsers',
      ip_title: 'IP Address',
      keyword_title: 'Keywords',
      metatag_title: 'Meta tag',
      metercheck_title: 'Meter Check',
      queryparams_title: 'Query Parameters',
      referrer_title: 'Referrer',
      starttime_title: 'Start Time',
      subscriberstatus_title: 'Subscriber Status',
      url_title: 'URL',
      urlpattern_title: 'URL Pattern',
      user_title: 'User login',
      useragent_title: 'User Agent',
      // Offer Group Preview
      offer_group_preview: 'Offer Group Preview',
      offer_group_preview_empty: 'Please select an offer group to generate a preview.',
      offer_group_preview_disabled:
        'Preview is disabled while creating new offer groups.',
      offer_group_preview_error:
        'Sorry, an error occured while generating the preview. Please verify the form is valid and try again.',
      offer_group_refresh_preview: 'Refresh the preview using the current form data.',
      offer_group_please_validate:
        'Please validate the form before refreshing the preview.',
    },

    components: {
      copy_button: {
        tooltip: {
          default: 'Copy to clipboard',
          success: 'Copied!',
          error: 'Failed to copy',
        },
      },
    },
    navigation: {
      common: {
        divider: 'Divider',
        ariaOpen: '{{label}} open',
        ariaClose: '{{label}} closed',
        ariaHeader: 'Header {{label}}',
      },
      beta_requires_program:
        'This feature is currently in beta. Contact Support if you have any questions.',
      settings: {
        label: 'Settings',
        general: 'General Settings',
        appearance: 'Appearance Settings',
        advanced: 'Advanced Settings',
        advanced_description:
          'Advanced Settings allow you to access and manage experimental features that we are currently testing. These features are rolled out in isolation to gather feedback and refine their functionality before a broader release.',
      },
      root: {
        home: 'Home',
        boards: 'Boards',
        dashboards_management: 'Dashboards',
      },
      assets: {
        title: 'Content Management',
        label: 'Assets',
        all: 'All Assets',
        articles: 'Articles',
        images: 'Images',
        videos: 'Videos',
        collections: 'Collections',
        templates: 'Templates',
        dashboard: 'Dashboard',
        video_dashboard: 'Video Plays',
        advanced_filters: 'Advanced Filters',
        quick_filters: 'Quick Filters',
        standard_filters: 'Standard Filters',
        more_filters: 'More Filters',
      },
      feeds: {
        label: 'Feeds',
        all: 'All Feeds',
        channels: 'Channels',
      },
      user: {
        title: 'Community',
        contacts: 'Contacts',
        all_contacts: 'All Contacts',
        admin_management: 'Admin Management',
        services: 'Services',
        all_services: 'All Services',
        reports: 'Reports',
        reports_dashboard: 'Subscription Activity',
        journeys: 'Journeys',
        all_journeys: 'All Journeys',
        email_reach: 'Email Reach',
        email_reach_search: 'All Accounts',
        email_reach_contacts: 'Contacts',
        email_reach_lists: 'Lists',
        email_reach_messages: 'Messages',
        multisite_search: 'Multi-Site Search',
        transactions: 'Transactions',
        transactions_search: 'All Transactions',
      },
      notifier: {
        title: 'Notifier',
        messages: 'Messages',
        channels: 'Channels',
        connections: 'Connections',
        settings: 'Settings',
        social_accounts: 'Social Accounts',
        automatic_notifications: 'Automatic Notifications',
      },
      design: {
        title: 'Design',
        maps: 'Maps',
      },
      dashboards: {
        home_dashboard: 'Home Dashboard',
        custom_dashboards: {
          title: 'Dashboards',
          title_alt: 'Boards',
        },
      },
    },
    reports: {
      domain_filter: {
        label: 'Domains',
        placeholder: 'Select domains',
        disabled_message: 'Audience+ entitlement is required to change domains.',
        clear: 'Clear domains',
      },
    },
    service: bloxEnglishServiceMessages,
    services: bloxEnglishServiceMessages,
    video_field_input: {
      uploading_percentage: 'Uploading... {{percentage}}%',
      uploading_poster: 'Uploading poster...',
      upload_success: 'File uploaded successfully.',
      upload_unsuccessful: 'File upload unsuccessful.',
      transfer_success: 'File transferred successfully!',
      transfer_error: 'Error transferring file.',
      error: {
        wait_upload: 'Please wait, uploading file...',
        file_required: 'Please attach a file.',

        no_video: 'No video found to capture screenshot from',
        no_file_playback: 'File not available for playback',
        canvas_context: 'Failed to get canvas context',
        screenshot_capture: 'Failed to capture screenshot',
        screenshot_upload: 'Failed to upload screenshot',
        poster_save: 'Failed to save as poster',
        media_playback: {
          generic: 'An unknown error occurred during media playback.',
          aborted: 'Media playback was aborted.',
          network_error:
            'A network error occurred which prevented the media from being successfully fetched.',
          decode_error:
            'The media playback was aborted due to an error occurring while trying to decode the media resource',
          format_converting: 'Video converting to web format. Preview available soon.',
        },
      },
      screenshot: {
        preview: 'Screenshot Preview',
        captured: 'Screenshot captured successfully',
        use_as_preview: 'Use as Preview',
        use_as_poster: 'Use as Poster',
        discard: 'Discard',
        saved: 'Screenshot saved successfully',
      },
      remote_url: {
        title: 'Add Video from URL',
        description:
          'Enter the URL of a video file or embed code from a supported service.',
      },
      play_to_capture: 'Play the video to capture a screenshot',
      not_supported: 'Screenshot capture not supported for this video',
      trim_video: {
        label: 'Trim video',
        help: 'Trim the video to a specific duration',
        description: 'Specify the start and end points to trim the video.',
        errors: {
          invalid_range: 'Invalid range: Start time must be before end time.',
          out_of_bounds: 'Out of bounds: Times must be within video duration.',
          processing: 'Error processing new video clip. Please try again.',
          unsupported_format: 'Unsupported format for video clipping.',
          unknown: 'An unknown error occurred during video clipping.',
        },
        actions: {
          preview: {
            label: 'Preview Trim',
            tooltip: 'Preview the trimmed video',
          },
          cancel: {
            label: 'Cancel Trim',
            tooltip: 'Cancel the trim operation',
          },
          trim_new: {
            label: 'Trim & New',
            tooltip: 'Create a new video with the trimmed section and duplicate metadata',
            success: 'Your trimmed video is being processed and will be ready shortly.',
            link_text: 'click here',
            instructions:
              "We're opening your video in a new tab. If it doesn't open automatically, <externalLink>click here</externalLink> to view your video",
            closing: 'Closing in {{seconds}} seconds',
          },
          play: {
            label: 'Play',
            tooltip: 'Play the video',
          },
          pause: {
            label: 'Pause',
            tooltip: 'Pause the video',
          },
          reverse: {
            label: 'Reverse 5 seconds',
            tooltip: 'Reverse the video',
          },
          forward: {
            label: 'Forward 5 seconds',
            tooltip: 'Forward the video',
          },
        },
        details: {
          in: 'In',
          out: 'Out',
          duration: 'Duration',
          original_duration: 'Original Duration',
        },
        fields: {
          title: {
            label: 'Title',
            placeholder: 'Enter title for trimmed video',
            default: '{{title}} (Trimmed)',
          },
        },
      },
    },
    download_menu: {
      label: 'Downloads',
      title: 'Exports',

      button: {
        tooltip: {
          all_ready: 'Exports ready',
          of: 'of',
          exports_ready: 'exports ready',
          preparing: 'Preparing exports',
        },
      },

      empty: {
        message: 'No active exports available.',
      },

      export: {
        label: 'Export',
        status: {
          ready: 'Ready to download',
          processing: 'Processing…',
        },
      },

      actions: {
        download: 'Download',
        delete: 'Delete',
        clear: 'Clear',
        close: 'Close',
      },

      notifications: {
        download_started: 'Download started',
        download_failed: 'Download failed',
        export_ready_suffix: 'export ready',
        export_cleared: 'Export cleared',
        export_processing: 'Export is still being processed',
        export_not_found: 'Export not found or expired',
      },

      footer: {
        availability: 'Your exports will be available for 24 hours.',
      },

      file: {
        prefix: 'blox',
        suffix: 'export',
      },
    },
    export_button: {
      label: 'Export',
      menu: {
        loading: 'Loading export options...',
      },
      notifications: {
        export_started: 'Export started',
        export_failed: 'Failed to start export',
        export_unavailable: 'Export function not available',
        load_options_failed: 'Failed to load export options',
      },
    },
    notification_return: {
      processing: 'Processing notification, please wait...',
      loading: 'Loading notification details...',
      preparing_download: 'Preparing your download...',
      downloading: 'Downloading...',
      modal: {
        title: 'Download Ready',
        description:
          'Review the details above and click Download to save the file to your device.',
      },
      success: {
        download_started: 'Your download has started',
      },
      error: {
        fetch_failed: 'Unable to load notification details. Please try again.',
        unknown_action: 'This notification action is not supported.',
        missing_export_id: 'Notification is missing the required export identifier.',
        download_failed: 'Failed to download the export file. Please try again.',
      },
    },
    notifications_panel: {
      title: 'Notifications',
      settings_title: 'Notifications Settings',
      mark_all_read: 'Mark all as read',
      filters: {
        all: 'All',
        unread: 'Unread ({{count}})',
        read: 'Read',
      },
      sections: {
        today: 'Today',
        earlier: 'Earlier',
      },
      empty: 'No notifications',
      error: 'Failed to load notifications',
      settings_placeholder: 'Settings content coming soon...',
    },
    welcome: {
      title: 'Welcome to ',
    },
  },
  wizard: {
    stepper: {
      currentStepToggle: 'Current step: {{label}}. Click to {{action}} all steps',
      collapse: 'collapse',
      expand: 'expand',
      stepCounter: 'Step {{current}} of {{total}}',
      listLabel: 'All steps',
      itemLabel: '{{label}}, step {{current}} of {{total}}',
      statusSuffix: ', {{status}}',
      status: {
        active: 'current step',
        completed: 'completed',
        disabled: 'disabled',
        inactive: 'inactive',
      },
      iconLabel: 'Step {{status}}',
      clickToGo: 'Click to go to this step',
      navigationLabel: 'Progress steps',
      regionLabel: 'Step progress indicator',
    },
    confirmClose: {
      title: 'Confirm Close',
      content: 'You have unsaved changes. Are you sure you want to close this wizard?',
      subtext: 'Closing the wizard will discard all unsaved changes.',
      confirm: 'Close Wizard',
      cancel: 'Cancel',
    },
  },
};
